<div class="header bg-gradient-danger pb-1 pt-5 pt-md-8">
  <div class="container-fluid">
    <div class="header-body"></div>
  </div>
</div>

<div class="container-fluid" style="margin-top: -4.1em">
  <mat-tab-group dynamicHeight [(selectedIndex)]="demo1TabIndex" (selectedTabChange)="onTabClick($event)">
    <mat-tab>
      <ng-template mat-tab-label> 1<br>
        Add New<br>
        Advertisement
      </ng-template>
      <div class="add-new-subscriber mat-elevation-z4">
        <form class="form" [formGroup]="ionicForm">
          <div class="form-row">
            <mat-form-field class="example-full-width" style="width: 60%; margin-left: 5%; margin-top: 2%">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="sadvtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span style="margin-left: 2%; margin-top: 3%; font-size: large; font-weight: bold;">OR</span>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" style="width: 30%; margin-left: 5%; margin-top: 2%">
              <mat-label>Mobile No :</mat-label>
              <input matInput formControlName="smobno" [matAutocomplete]="automob" />
              <mat-autocomplete autoActiveFirstOption #automob="matAutocomplete">
                <mat-option (onSelectionChange)="selected_mob_no($event, option)"
                  *ngFor="let option of filteredOptions2 | async" [value]="option['mobile']">
                  {{ option["mobile"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span style="margin-left: 2%; margin-top: 3%; font-size: large; font-weight: bold;">OR</span>
            <mat-form-field class="example-full-width" style="width: 30%; margin-left: 3%; margin-top: 2%">
              <mat-label>Owner Name :</mat-label>
              <input matInput formControlName="sownername" [matAutocomplete]="autoownername" />
              <mat-autocomplete autoActiveFirstOption #autoownername="matAutocomplete">
                <mat-option (onSelectionChange)="selected_owner_name($event, option)"
                  *ngFor="let option of filteredOptions3 | async" [value]="option['owner_name']">
                  {{ option["owner_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <div style="margin-top: 3%;margin-left: 2%;">
              <button style="margin-left: 7%" type="button" mat-raised-button color="primary" (click)="selected_name()">
                Find
              </button>
            </div>
          </div>

          <div class="tableFixHead1">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Booking Date</th>
                  <th>Advertiser Name</th>
                  <th>Customer Name</th>
                  <th>Issue Name</th>
                  <th>Issue Date</th>
                  <th>Advt. Size</th>
                  <th>Advt. Amount</th>
                  <th>Page No</th>
                  <th>Representative Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of advtSubDetails; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item["booking_date"] }}</td>
                  <td>{{ item["advt_name"] }}</td>
                  <td>{{ item["cust_name"] }}</td>
                  <td>{{ item["issue_name1"] }}</td>
                  <td>{{ item["issue_date1"] }}</td>
                  <td>{{ item["advt_size1"] }}</td>
                  <td>{{ item["amount"] }}</td>
                  <td>{{ item["page_no"] }}</td>
                  <td>{{ item["rep_name"] }}</td>
                  <td>
                    <button class="btn-sm btn-outline-info" type="button" (click)="selectAdvtIssue(item)">
                      Select
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          <div class="form-row" style="
              justify-content: center;
              background-color: #8bbdbd;
              margin-bottom: 2%;
              margin-top: 2%;
            ">
            <h2 style="text-align: center; margin-top: 10px; color: black">
              Personal Details
            </h2>

            <!-- <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>
    
                <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i> -->

            <div class="arrow-container">
              <i class="fas fa-arrow-down" *ngIf="!showFields" (click)="toggleFields()"></i>
              <i class="fas fa-arrow-up" *ngIf="showFields" (click)="toggleFields()"></i>
            </div>


          </div>

          <ng-container *ngIf="showFields">
            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%">
                <mat-label>Advertiser Name :</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%">
                <mat-label>Company Owner Name :</mat-label>
                <input matInput formControlName="ownername" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 85%; margin-left: 5%">
                <mat-label>Address</mat-label>
                <textarea matInput placeholder="Address" formControlName="address" required></textarea>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field style="margin-left: 5%; width: 25%" class="example-full-width">
                <mat-label>Pincode</mat-label>
                <input (change)="getPincode($event)" matInput #postalCode maxlength="6" placeholder=""
                  formControlName="pincode" required />
                <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
              </mat-form-field>

              <mat-form-field style="width: 25%; margin-left: 5%">
                <mat-label>Country</mat-label>
                <mat-select (selectionChange)="getCountry($event)" formControlName="country" required>
                  <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="width: 25%; margin-left: 5%">
                <mat-label>State</mat-label>
                <mat-select (selectionChange)="getState($event)" formControlName="state">
                  <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field style="width: 25%; margin-left: 5%">
                <mat-label>District</mat-label>
                <mat-select (selectionChange)="getDistricts($event)" formControlName="district">
                  <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">
                    {{ c["district_name"] }}
                  </mat-option>
                </mat-select>
                <span>{{ selectedCity }}</span>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 5%">
                <mat-label>Taluka</mat-label>
                <mat-select formControlName="taluka">
                  <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"]
                    }}</mat-option>
                </mat-select>
                <span>{{ selectedTaluka }}</span>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" style="margin-left: 5%; width: 25%"
                [style.color]="validmobile ? null : 'red'">
                <mat-label>Mobile</mat-label>
                <span matPrefix>+91 &nbsp;</span>
                <input type="tel" #mobiles (change)="validateMobile($event)" maxlength="10"
                  formControlName="mobileNumber" matInput />
                <mat-hint align="end">{{ mobiles.value.length }} / 10</mat-hint>
                <mat-error *ngIf="validmobile">
                  Please enter a valid mobile no.
                </mat-error>
                <mat-error *ngIf="validmobile">
                  Mobile no. is <strong>required</strong>
                </mat-error>
              </mat-form-field>



              <mat-form-field class="example-full-width" style="margin-left: 5%; width: 25%">
                <mat-label>Landline No.</mat-label>
                <input type="text" #land maxlength="12" formControlName="landline_no" matInput />
                <mat-hint align="end">{{ land.value.length }} / 12</mat-hint>
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 5%"
                [style.color]="validemail ? null : 'red'">
                <mat-label>Email</mat-label>
                <input (change)="validateEmail($event)" type="email" matInput formControlName="email"
                  placeholder="Ex. pat@example.com" />
                <mat-error *ngIf="validemail">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="validemail">
                  Email is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field style="margin-left: 5%; width: 25%">
                <mat-label>Date of Birth :</mat-label>
                <input formControlName="dob" matInput [matDatepicker]="datepicker" (dateChange)="validatedob($event)" />
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker> </mat-datepicker>
                <mat-error *ngIf="validdob"> Please enter a valid DOB </mat-error>
                <mat-error *ngIf="validdob">
                  DOB is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field style="margin-left: 5%; width: 25%">
                <mat-label>Company Registration Date :</mat-label>
                <input formControlName="companyRegistration" matInput [matDatepicker]="datepicker1" />
                <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
                <mat-datepicker #datepicker1> </mat-datepicker>
              </mat-form-field>

              <mat-form-field style="margin-left: 5%; width: 25%">
                <mat-label>Advt. Type : </mat-label>
                <mat-select formControlName="advtType" required>
                  <mat-option *ngFor="let item of advtTypes" value="{{ item['advt_types_select'] }}">
                    {{ item["advt_type"] }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 5%">
                <mat-label>Advertiser Name (In English) :</mat-label>
                <input matInput formControlName="e_advt_name" />
              </mat-form-field>

              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 5%">
                <mat-label>District (In English) :</mat-label>
                <input matInput formControlName="e_district" />
              </mat-form-field>

              <mat-form-field style="margin-left: 5%; width: 25%" class="example-full-width">
                <mat-label>Gst No.</mat-label>
                <input matInput type="text" placeholder="Gst No." formControlName="gstno" />
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field style="margin-left: 5%; width: 40%">
                <mat-label>Representative Name :</mat-label>
                <input formControlName="rep_name" matInput [matAutocomplete]="autorepname" />
                <mat-autocomplete autoActiveFirstOption #autorepname="matAutocomplete">
                  <mat-option (onSelectionChange)="SelectRepresentative(option)"
                    *ngFor="let option of filteredOptions1 | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field style="margin-left: 5%; width: 40%">
                <mat-label>Representative Mobile No :</mat-label>
                <input type="number" formControlName="rep_mobile_no" matInput />
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field style="margin-left: 5%; width: 40%">
                <mat-label>Instruction :</mat-label>
                <input type="text" formControlName="instruction" matInput />
              </mat-form-field>
            </div>

            <div>
              <button *ngIf="!advtshow" type="button" [disabled]="ionicForm.invalid" mat-raised-button
                class="btn btn-primary" style="width: 45%; margin-left: 15%; margin-right: 05%" (click)="saveAdvt()">
                Save
              </button>
              <button *ngIf="advtshow" type="button" mat-raised-button class="btn btn-info"
                style="width: 45%; margin-left: 15%; margin-right: 05%" (click)="updateAdvt()">
                Update
              </button>
              <button type="button" mat-raised-button color="warn" style="width: 20%" (click)="advtCancel()">
                Delete
              </button>
            </div>

            <div class="form-row" style="margin-top: 5%;">
              <button type="button" (click)="enableDisableRule('Special Issue')" [ngStyle]="{
                'background-color': toggle ? '#f4dd6a' : '#87e0ec'
              }" style="
                width: 20%;
                margin-left: 5%;
                height: 06vh;
                margin-top: 10px;
              ">
                Special Issue
              </button>
              <button type="button" (click)="enableDisableRule('Occasional')" [ngStyle]="{
                'background-color': toggle1 ? '#f4dd6a' : '#87e0ec'
              }" style="width: 20%; color: #0e1f7e; height: 06vh; margin-top: 10px">
                Occasional
              </button>
              <button type="button" (click)="enableDisableRule('Contract')" [ngStyle]="{
                'background-color': toggle2 ? '#f4dd6a' : '#87e0ec'
              }" style="width: 20%; color: #e82b0a; height: 06vh; margin-top: 10px">
                Contract
              </button>
            </div>
          </ng-container>
        </form>

        <form [formGroup]="contractForm">
          <div *ngIf="toggle2">
            <div class="form-row" style="
                          justify-content: center;
                          background-color: #8bbdbd;
                          margin-bottom: 2%;
                          margin-top: 2%;
                        ">
              <h2 style="text-align: center; margin-top: 10px; color: black">
                Contract Details
              </h2>
              <div class="arrow-container1">
                <i class="fas fa-arrow-down" *ngIf="!showFields1" (click)="toggleContractForm()"></i>
                <i class="fas fa-arrow-up" *ngIf="showFields1" (click)="toggleContractForm()"></i>
              </div>
            </div>
            <div *ngIf="showFields1">
              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Contract No :</mat-label>
                  <input type="text" formControlName="contractno" matInput required readonly />
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Date</mat-label>
                  <input matInput type="date" formControlName="contractdate" [min]="financialYearMin"
                    [max]="financialYearMax" required />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Representative Name :</mat-label>
                  <input formControlName="repname" matInput [matAutocomplete]="autorepname2" />
                  <mat-autocomplete autoActiveFirstOption #autorepname2="matAutocomplete">
                    <mat-option (onSelectionChange)="selected_rep_name1($event, option)"
                      *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Office Representative Name :</mat-label>
                  <input type="text" formControlName="offrepname" matInput />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Advt Name :</mat-label>
                  <input type="text" formControlName="advtname" matInput />
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Privious Balance Rs :</mat-label>
                  <input type="number" formControlName="priviousbal" matInput (input)="onAmountChange()" />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label> New Contract Amount Rs :</mat-label>
                  <input type="number" formControlName="contractamt" matInput (input)="onAmountChange()" />
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Discount Rs :</mat-label>
                  <input type="number" formControlName="discountamt" matInput (input)="onAmountChange()" />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>GST Percentage (%) :</mat-label>
                  <mat-select formControlName="gstpercentage" (selectionChange)="onGstPercentageChange($event)">
                    <mat-option value="5">5%</mat-option>
                    <mat-option value="12">12%</mat-option>
                    <mat-option value="18">18%</mat-option>
                    <mat-option value="28">28%</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div style="margin-left: 5%; margin-top: 2%; margin-bottom: 2%">
                <mat-radio-group aria-label="Select an option" formControlName="gstie">
                  <mat-radio-button value="gstInclude" style="margin-right: 5%"
                    (change)="calculateNetGstAmt($event)">GST Including
                  </mat-radio-button>
                  <mat-radio-button value="gstExclude" (change)="calculateNetGstAmt($event)">GST Excluding
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Net Amount :</mat-label>
                  <input type="number" formControlName="netamt" matInput readonly />
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 18%">
                  <mat-label>GST Rs. :</mat-label>
                  <input type="number" formControlName="netgstprice" matInput readonly />
                </mat-form-field>
                <mat-form-field style="margin-left: 4%; width: 18%">
                  <mat-label>Contract Total Rs. :</mat-label>
                  <input type="number" formControlName="nettotal" matInput readonly />
                </mat-form-field>
              </div>


              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 20%">
                  <mat-label>Previous + New Contract:</mat-label>
                  <input type="number" formControlName="balamt" matInput readonly />
                </mat-form-field>

                <mat-form-field style="margin-left: 5%; width: 20%">
                  <mat-label>Booking Advt Amount :</mat-label>
                  <input type="number" formControlName="bookingadvtamt" (keyup)="calculatebookingamt()" matInput />
                </mat-form-field>

                <!-- FIXED: was formControlName="bookingadvtamt" — now separate readonly field -->
                <mat-form-field style="margin-left: 5%; width: 20%">
                  <mat-label>Balance Amount :</mat-label>
                  <input type="number" formControlName="actualbalamt" matInput readonly />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Contract Period form</mat-label>
                  <input matInput type="date" formControlName="contractfromdate" [min]="financialYearMin"
                    [max]="financialYearMax" required />
                </mat-form-field>
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>To</mat-label>
                  <input matInput type="date" formControlName="contracttodate" [min]="financialYearMin"
                    [max]="financialYearMax" required />
                </mat-form-field>
              </div>


              <div class="form-row">
                <mat-form-field style="margin-left: 5%; width: 40%">
                  <mat-label>Instruction :</mat-label>
                  <textarea type="number" formControlName="instruction" matInput></textarea>
                </mat-form-field>
              </div>

              <div style="margin-top: 3%; margin-bottom: 3%">
                <button *ngIf="!contractshow" type="button" [disabled]="contractForm.invalid" mat-raised-button
                  class="btn btn-primary" style="width: 45%; margin-left: 15%; margin-right: 05%"
                  (click)="saveContract()">
                  Save
                </button>
                <button *ngIf="contractshow" type="button" mat-raised-button class="btn btn-info"
                  style="width: 45%; margin-left: 15%; margin-right: 05%" (click)="updateContract()">
                  Update
                </button>
                <button type="button" mat-raised-button color="warn" style="width: 20%" (click)="cancelContract()">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </form>



        <div class="form-row" style="
                      justify-content: center;
                      background-color: #8bbdbd;
                      margin-bottom: 2%;
                      margin-top: 2%;
                    ">
          <h2 style="text-align: center; margin-top: 10px; color: black">
            Advt. Booking Details
          </h2>
        </div>

        <form [formGroup]="issueForm" (ngSubmit)="saveAdvtSubDetails()">
          <div class="form-row">
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 40%">
              <mat-label>Booking Date</mat-label>
              <input matInput type="date" formControlName="bookingdate" [min]="financialYearMin"
                [max]="financialYearMax" (change)="bookingdateChange($event)" />
            </mat-form-field>

            <!-- Toggle between New and Deleted Booking -->
            <mat-button-toggle-group formControlName="newordeletedBooking" (change)="newordelbooking($event)"
              name="bookingStyle" aria-label="Booking Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>

            <!-- Input field for New Booking Number -->
            <mat-form-field *ngIf="!deleterec" style="margin-left: 20px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Booking No :</mat-label>
              <input matInput type="text" formControlName="bookingno" readonly />
            </mat-form-field>

            <!-- Dropdown for Deleted Booking Numbers -->
            <mat-form-field *ngIf="deleterec" style="margin-left: 20px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Booking No (deleted):</mat-label>
              <mat-select formControlName="bookingno" required>
                <mat-option *ngFor="let receipt of getdeletedBookings" [value]="receipt.rcpt_no">
                  {{ receipt.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%; width: 40%">
              <mat-label>Advertiser Name :</mat-label>
              <input type="text" formControlName="advtname" matInput />
            </mat-form-field>
            <mat-form-field style="margin-left: 5%; width: 40%">
              <mat-label>Customer Name :</mat-label>
              <input type="text" formControlName="custname" matInput />
            </mat-form-field>
          </div>

          <div class="form-row">
            <div style="margin-left: 5%; width: 25%">
              <mat-form-field style="width: 100%">
                <mat-label>Representative Name :</mat-label>
                <input formControlName="repname" matInput [matAutocomplete]="autorepname1" required />
                <mat-autocomplete autoActiveFirstOption #autorepname1="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_rep_name($event, option)"
                    *ngFor="let option of filteredOptions4 | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <div style="color: red;font-size: 12px;  margin: -15px 10px;" *ngIf="!isrepValid">
                Please fill Representative Name
              </div>
            </div>

            <mat-form-field style="margin-left: 5%; width: 25%">
              <mat-label>Representative Mobile No :</mat-label>
              <input type="number" formControlName="rep_mobile_no" matInput />
            </mat-form-field>
            <mat-form-field style="margin-left: 5%; width: 25%">
              <mat-label>Office Representative Name :</mat-label>
              <input type="text" formControlName="offrepname" matInput />
            </mat-form-field>
          </div>

          <div class="form-row" style="margin-top: 3%">
            <mat-form-field style="margin-left: 5%; width: 24%">
              <mat-label>Issue/grantha : </mat-label>

              <mat-select (selectionChange)="getIssues($event)" formControlName="issue" required>
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- This will show ONLY when "नियमित अंक" is selected -->
            <mat-form-field *ngIf="showSubCategory()" style="margin-left: 3%; width: 24%">
              <mat-label>Sub Category : </mat-label>
              <mat-select formControlName="subCategory">
                <mat-option value="करार">करार</mat-option>
                <mat-option value="प्रासंगिक">प्रासंगिक</mat-option>
              </mat-select>
              <mat-option *ngIf="subCategory" [value]="subCategory">
                {{ subCategory }}
              </mat-option>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 24%">
              <mat-label>Issue Dates : </mat-label>
              <mat-select #mySel (selectionChange)="getAdvtDates($event);  addcate($event)" formControlName="issuedates"
                required>
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ [item['issueDate'] | date : 'dd/MM/yyyy',item['issueName'],
          item['publishedDate'] | date : 'dd/MM/yyyy',- item.id] }}">{{ item["issueDate"] | date : "dd/MM/yyyy"
                  }} {{ item["issueName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 24%">
              <mat-label>Advt. Sizes : </mat-label>
              <mat-select (selectionChange)="getAdvtSize($event)" formControlName="advtsize" required
                [compareWith]="compareFn">
                <mat-option *ngFor="let item of advtsizebyCategory" [value]="item">
                  {{ item["Advt_size"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button *ngIf="ds_advtId == 0" type="button" style="height: 1%; margin-left: 3%; margin-top: 1%"
              mat-raised-button color="warn" (click)="addAdvt()">
              Add
            </button>
            <button *ngIf="ds_advtId !== 0" type="button" style="height: 1%; margin-left: 3%; margin-top: 1%"
              mat-raised-button color="primary" (click)="modifyAdvt()">
              Update
            </button>
          </div>

          <div class="form-row">
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Issue Granth</th>
                  <th>Issue Name</th>
                  <th>Dates</th>
                  <th>Advt. Size</th>
                  <!-- <th>Action</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sub of AdvtDetails; let i = index">
                  <td>{{ sub.s_no }}</td>
                  <td>{{ sub["issue"] }}</td>
                  <td>{{ sub["issue_name1"] }}</td>
                  <td>{{ sub["issue_date1"] }}</td>
                  <td>{{ sub["advtsize"]?.Advt_size || sub["advtsize"] }}</td>
                  <td>
                    <button *ngIf="ds_advtId == 0" type="button" class="btn btn-danger btn-sm" (click)="deleteAdvt(i)">
                      Remove
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%; margin-top: 10px; width: 40%" class="example-full-width">
              <mat-label>RO Number</mat-label>
              <input type="text" formControlName="ro_number" matInput />
            </mat-form-field>

            <mat-form-field style="margin-top: 10px; margin-left: 5%; width: 40%" class="example-full-width">
              <mat-label>RO Date : </mat-label>
              <input matInput type="date" [min]="financialYearMin" [max]="financialYearMax"
                formControlName="ro_dates" />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%; width: 40%" class="example-full-width">
              <mat-label>Instruction</mat-label>
              <textarea matInput type="text" placeholder="Instruction" formControlName="instruction">
      </textarea>
            </mat-form-field>

            <mat-form-field style="margin-left: 5%; width: 40%" class="example-full-width">
              <mat-label>Other Details</mat-label>
              <textarea matInput type="text" placeholder="Tapshil" formControlName="otherdetls">
      </textarea>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%; width: 40%" class="example-full-width">
              <mat-label>Page No. :</mat-label>
              <input matInput type="number" formControlName="pageno" />
            </mat-form-field>
          </div>


          <!-- <mat-form-field style="margin-left: 5%; width: 40%" class="example-full-width">
    <mat-label>Advt. Amount :</mat-label>
    <input matInput type="number" formControlName="advtamout" />
  </mat-form-field> -->

          <div class="form-group">
            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%">
              <mat-label>Advt. Amount :</mat-label>
              <span matPrefix>₹ &nbsp;</span>
              <input matInput formControlName="advtamout" type="number" required [readonly]="isFieldReadonly()"
                (click)="showAlert()" />
            </mat-form-field>
            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%">
              <mat-label>Advt. Discount : </mat-label>

              <input matInput type="number" formControlName="advtdiscount" />
              <span matPrefix>% &nbsp;</span>
            </mat-form-field>
          </div>

          <div class="form-row">
            <span style="
        margin-top: 0%;
        margin-left: 5%;
        margin-bottom: 2%;
        font-weight: bold;
      ">
              Total Discount :
              {{
              this.advtamount * (this.discount / 100)
              | currency : "INR" : "symbol"
              }}
            </span>
            <span style="margin-left: 32%; font-weight: bold">
              Total Amount: {{ issueForm.get('totalamt')?.value | currency: 'INR':'symbol' }}
            </span>
          </div>

          <div class="form-group" style="margin-left: 5%">
            <mat-radio-group aria-label="Select an option" formControlName="gstie">
              <mat-radio-button value="gstInclude" style="margin-right: 5%" (change)="changeType($event)">GST Including
              </mat-radio-button>
              <mat-radio-button value="gstExclude" (change)="changeType($event)">GST Excluding</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="form-group">
            <mat-form-field class="example-full-width" *ngIf="!showigst" style="width: 35%; margin-left: 5%">
              <mat-label>GST 5% (SGST-2.5% + CGST-2.5%):</mat-label>
              <span matPrefix>₹ &nbsp;</span>
              <input readonly matInput formControlName="gstamount" type="number" />
              <!-- Display CGST & SGST -->
              <div matSuffix style="margin-right: 45px; white-space: nowrap;margin-top: 10px; margin-top: 15px;">
                CGST: {{ commission_cgst }} | SGST: {{ commission_sgst }}
              </div>
            </mat-form-field>

            <mat-form-field class="example-full-width" *ngIf="showigst" style="width: 20%; margin-left: 5%">
              <mat-label>IGST {{percentage}}% : </mat-label>
              <span matPrefix>₹ &nbsp;</span>
              <input readonly matInput type="number" formControlName="igstamount" />
            </mat-form-field>
            <span style="margin-left: 2%; font-weight: bold">+</span>
            <mat-form-field class="example-full-width" style="width: 20%; margin-left: 2%; margin-top: 20px">
              <mat-label>Amount: </mat-label>
              <span matPrefix>₹ &nbsp;</span>
              <input readonly matInput formControlName="totalamt" type="number" />
            </mat-form-field>
            <span style="margin-left: 2%; font-weight: bold">=</span>
            <mat-form-field class="example-full-width" style="width: 25%; margin-left: 2%; margin-top: 20px">
              <mat-label>Total Amount: </mat-label>
              <span matPrefix>₹ &nbsp;</span>
              <input readonly matInput formControlName="amount" type="number" />
            </mat-form-field>
          </div>

          <div style="margin-top: 3%">
            <button *ngIf="!issueshow" type="submit" [disabled]="issueForm.invalid" mat-raised-button
              class="btn btn-primary" [disabled]="issueForm.invalid || isButtonDisabled"
              style="width: 45%; margin-left: 15%; margin-right: 05%">
              Save
            </button>
            <button *ngIf="issueshow" type="button" mat-raised-button class="btn btn-info"
              [disabled]="issueForm.invalid || isButtonDisabled" style="width: 45%; margin-left: 15%; margin-right: 05%"
              (click)="updateAdvtSubDetails()">
              Update
            </button>
            <button type="button" mat-raised-button color="warn" [disabled]="issueForm.invalid || isButtonDisabled"
              style="width: 20%" (click)="cancelAdvtSubDetails()">
              Delete
            </button>
          </div>
        </form>
      </div>
    </mat-tab>

    <!-- <mat-tab label="Search Advertisement">
      <mat-form-field class="example-form-field" style="margin-top: 5%">
        <mat-label>Advt. Name</mat-label>
        <input matInput type="text" [(ngModel)]="advt_name" (ngModelChange)="get_advt_name_filter($event)" />
      </mat-form-field>

      <span style="margin-left: 1%; font-size: large; font-weight: bold">
        OR
      </span>

      <mat-form-field class="example-form-field" style="margin-left: 1%">
        <mat-label>Cust. Mobile No.</mat-label>
        <input matInput type="tel" [(ngModel)]="cust_mobile_filter" #cust_mobile1 maxlength="10"
          (ngModelChange)="getcust_mobile_filter($event)" />
        <button *ngIf="cust_mobile_filter" matSuffix mat-icon-button aria-label="Clear"
          (click)="reset_cust_mobile_filter($event)">
          <mat-icon>close</mat-icon>
          <mat-hint align="end">{{ cust_mobile1.value.length }} / 10</mat-hint>
        </button>
      </mat-form-field>

      <span style="margin-left: 1%; font-size: large; font-weight: bold">
        OR
      </span>

      <mat-form-field style="margin-left: 1%">
        <mat-label>Issue Wise Advt.</mat-label>
        <mat-select name="issue" (selectionChange)="getIssuesSearchAdvt($event)">
          <mat-option *ngFor="let issue of advt_mag_name_details" [value]="issue['issue_name']">
            {{ issue["issue_name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <span style="margin-left: 1%; font-size: large; font-weight: bold">
        OR
      </span>

      <mat-form-field class="example-form-field" style="margin-left: 1%">
        <mat-label>Rep. Name</mat-label>
        <input matInput type="text" [(ngModel)]="rep_name" (ngModelChange)="get_rep_name_filter($event)" />
      </mat-form-field>

      <button style="margin-left: 2%" (click)="getAdvtReport()" mat-raised-button color="primary">
        Find
      </button>

      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नोंदणी दिनांक</th>
                <th>ग्राहकाचे नाव</th>
                <th>संपर्क क्रमांक</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>Issue Name / Grantha</th>
                <th colspan="5">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let advt of this.getAdvtDetails; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ advt["registration_date"] | date : "dd-MM-yyy" }}</td>
                <td>{{ advt["name"] }}</td>
                <td>{{ advt["mobile"] }}</td>
                <td>{{ advt["rep_name"] }}</td>
                <td>{{ advt["issue_name"] }}</td>
                <td>
                  <button type="button" class="btn btn-danger btn-sm" (click)="view_advt(advt)">
                    View
                  </button>
                </td>
                
                <td>
                  <button type="button" class="btn btn-success btn-sm" (click)="addIssueDates(advt)">
                    Manage Issue Date
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-success btn-sm" (click)="addPublishDates(advt)">
                    Add Publish Date
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-danger btn-sm" (click)="Cancel_advt(advt)">
                    Delete Advt
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab> -->

    <mat-tab>
      <ng-template mat-tab-label>2<br>
        Advt.Registration<br>
        Report
      </ng-template>
      <form class="form" [formGroup]="RegistrationreportRange">
        <mat-form-field appearance="outline" style="width: 30%; margin-top: 5%;">
          <mat-label>Advt. Received Date</mat-label>

          <div class="date-inline">
            <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
            <span class="dash"> - </span>
            <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
              (blur)="getChangedDateRegistrationReport()" />
          </div>
        </mat-form-field>



        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%;width: 35%;">
          <mat-label>Representative : </mat-label>
          <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
            <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
            <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%;width: 35%;">
          <mat-label>Office Representative : </mat-label>
          <mat-select #mySelr1 (selectionChange)="getOfficeRep($event)" formControlName="offrepname" multiple>
            <mat-option value="ALL" (click)="toggleAllSelectionr1()">All</mat-option>
            <mat-option *ngFor="let item of pp_off_rep_names" value="{{ item['off_rep_name'] }}">{{
              item["off_rep_name"] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%;width: 35%;">
          <mat-label>Issue/grantha : </mat-label>
          <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
            <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
              {{ item.category }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="margin-left: 2%;width: 40%;">
          <mat-label>Issue Dates : </mat-label>
          <mat-select #mySel2 (selectionChange)="getAdvtDates1($event)" formControlName="issuedate" multiple required>
            <mat-option value="ALL" (click)="toggleAllSelection2()">All</mat-option>
            <!-- <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{
                                [
                                  item['issueDate'] | date : 'dd/MM/yyyy',
                                  item['issueName']'
                                ]
                              }}">{{ item["issueDate"] | date :
            "dd/MM/yyyy" }}
            {{ item["issueName"] }} 
          </mat-option> -->
            <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] | date
              :
              "dd/MM/yyyy" }}
              {{ item["issueName"] }}

            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="margin-left: 3%">
          <mat-label>Select TikkWIse</mat-label>
          <mat-select (selectionChange)="gettikwise($event)" formControlName="tiktype">
            <mat-option value="tikk">Tikk
            </mat-option>
            <mat-option value="notikk">Without Tikk
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%;width: 35%;">
          <mat-label>Select Type Of Report</mat-label>
          <mat-select (selectionChange)="checkReportType($event)">
            <mat-option value="InDetail"> In Detail </mat-option>
            <mat-option value="Briefly"> Briefly </mat-option>
            <mat-option value="Represantative Indetails">Indetails-Represantative</mat-option>
            <mat-option value="Represantative Briefly">Briefly-Represantative </mat-option>
            <mat-option value="Represantative very Briefly">Very Briefly-Represantative</mat-option>
            <mat-option value="Off_Represantative Indetails">Indetails-Off-Represantative</mat-option>
            <mat-option value="Off_Represantative Briefly">Briefly-Off-Represantative</mat-option>
            <mat-option value="Off_Represantative very Briefly">Very Briefly-Off-Represantative</mat-option>
            <mat-option value="Datewise Indetails">Indetails-datewise</mat-option>
            <mat-option value="Datewise Briefly">Briefly-Datewise</mat-option>
            <mat-option value="datewise very Briefly">very Briefly-Datewise</mat-option>
          </mat-select>
        </mat-form-field>

      </form>

      <button style="margin-left: 3%" (click)="getAdvtRegistrationReport()" mat-raised-button color="primary">
        Find
      </button>

      <mat-card *ngIf="showindetail">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="3">Vivek Saptahik</th>
                <th colspan="5">Advt. Registreation Report</th>
                <th colspan="2">In Detail</th>
                <th colspan="2"></th>
                <th colspan="3"></th>
                <th colspan="3">Date :</th>
              </tr>
              <tr>
                <th colspan="3">Date. From :</th>
                <th colspan="2">To :</th>
                <th colspan="3">Issue/Grantha Categary :</th>
                <th colspan="2">Issue Date :</th>
                <th colspan="5">Issue Name :</th>
                <th colspan="3">Page No</th>
              </tr>
              <tr>
                <th>Issue Sr. No</th>
                <th>Booking Date</th>
                <th>Booking No</th>
                <th>Advertiser Name</th>
                <th>Customer Name</th>
                <th>Representative Name</th>
                <th>Mobile No</th>
                <th>Office Represantative Name</th>
                <th>RO Number</th>
                <th>Instruction</th>
                <th>Advt.Size</th>
                <th>Advt Amount Rs</th>
                <th>Net Amount</th>
                <th>GST 5%</th>
                <th>Total Amount</th>
                <th>Received Amount</th>
                <th>Receipt No. and Date</th>
                <th>Pending Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredinDetailsRegReport; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item["booking_date"] | date : "dd-MM-yyy" }}</td>
                <td>{{ item["booking_no"] }}</td>
                <td>{{ item["advt_name"] }}</td>
                <td>{{ item["cust_name"] }}</td>
                <td>{{ item["rep_name"] }}</td>
                <td>{{ item["rep_mob_no"] }}</td>
                <td>{{ item["off_rep_name"] }}</td>
                <td>{{ item["ro_no"] }}</td>
                <td>{{ item["instruction"] }}</td>
                <td>{{ item["advtsize"] }}</td>
                <td>{{ item["advt_amt"] }}</td>
                <td>{{ item["total_amount"] }}</td>
                <td>{{ toInt(item["sgst"]) + toInt(item["cgst"]) }}</td>
                <td>{{ item["amount"] }}</td>
                <td>{{ item["part_pymt_amt"] }}</td>
                <td>
                  {{ item["rep_rcpt_no"] }}<br />
                  {{ item["rcpt_date"] | date : "dd-MM-yyy" }}
                </td>
                <td>{{ item["part_pymt_remaning_amt"] }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2">Total</td>
                <td colspan="2">
                  Total No of Advt :
                  {{ this.inDetailsRegReportTotal.total_advt }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ this.inDetailsRegReportTotal.advt_total }}</td>
                <td>{{ this.inDetailsRegReportTotal.net_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.gst }}</td>
                <td>{{ this.inDetailsRegReportTotal.total_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.rcvd_amt }}</td>
                <td></td>
                <td>{{ this.inDetailsRegReportTotal.pndg_amt }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </mat-card>

      <mat-card *ngIf="showindetaildatewise">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>
          <div *ngFor="let data of inDetailsRegReportsubTotalData;
                      let s = index; let end = last
                      ">
            <table class="table table-bordered">
              <thead *ngIf="s == 0">
                <tr>
                  <th colspan="3">Vivek Saptahik</th>
                  <th colspan="5">Advt. Registreation Report</th>
                  <th colspan="2">Datewise</th>
                  <th colspan="2">In Detail</th>
                  <th colspan="3"></th>
                  <th colspan="3">Date :</th>
                </tr>
                <tr>
                  <th colspan="3">Date. From :</th>
                  <th colspan="2">To :</th>
                  <th colspan="3">Issue/Grantha Categary :</th>
                  <th colspan="2">Issue Date :</th>
                  <th colspan="5">Issue Name :</th>
                  <th colspan="3">Page No</th>
                </tr>
                <tr>
                  <th>Issue Sr. No</th>
                  <th>Booking Date</th>
                  <th>Booking No</th>
                  <th>Advertiser Name</th>
                  <th>Customer Name</th>
                  <th>Representative Name</th>
                  <th>Mobile No</th>
                  <th>Office Represantative Name</th>
                  <th>RO Number</th>
                  <th>Instruction</th>
                  <th>Advt.Size</th>
                  <th>Advt Amount Rs</th>
                  <th>Net Amount</th>
                  <th>GST 5%</th>
                  <th>Total Amount</th>
                  <th>Received Amount</th>
                  <th>Receipt No. and Date</th>
                  <th>Pending Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="i == 0" colspan="3">Date</td>
                  <td *ngIf="i == 0">{{ item["booking_date"] | date : "dd-MM-yyy" }}</td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                </tr>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="!last">{{ i + 1 }}</td>
                  <td *ngIf="!last">{{ item["booking_date"] | date : "dd-MM-yyy" }}</td>
                  <td *ngIf="!last">{{ item["booking_no"] }}</td>
                  <td *ngIf="!last">{{ item["advt_name"] }}</td>
                  <td *ngIf="!last">{{ item["cust_name"] }}</td>
                  <td *ngIf="!last">{{ item["rep_name"] }}</td>
                  <td *ngIf="!last">{{ item["rep_mob_no"] }}</td>
                  <td *ngIf="!last">{{ item["off_rep_name"] }}</td>
                  <td *ngIf="!last">{{ item["ro_no"] }}</td>
                  <td *ngIf="!last">{{ item["instruction"] }}</td>
                  <td *ngIf="!last">{{ item["advtsize"] }}</td>
                  <td *ngIf="!last">{{ item["advt_amt"] }}</td>
                  <td *ngIf="!last">{{ item["total_amount"] }}</td>
                  <td *ngIf="!last">{{ toInt(item["sgst"]) + toInt(item["cgst"]) }}</td>
                  <td *ngIf="!last">{{ item["amount"] }}</td>
                  <td *ngIf="!last">{{ item["part_pymt_amt"] }}</td>
                  <td *ngIf="!last">
                    {{ item["rep_rcpt_no"] }}<br />
                    {{ item["rcpt_date"] | date : "dd-MM-yyy" }}
                  </td>
                  <td *ngIf="!last">{{ item["part_pymt_remaning_amt"] }}</td>
                </tr>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="last" colspan="2">Total</td>
                  <td *ngIf="last" colspan="2">
                    Total No of Advt : {{ item["total_advt"] }}
                  </td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last">{{ item["advt_total"] }}</td>
                  <td *ngIf="last">{{ item["net_amt"] }}</td>
                  <td *ngIf="last">{{ item["gst"] }}</td>
                  <td *ngIf="last">{{ item["total_amt"] }}</td>
                  <td *ngIf="last">{{ item["rcvd_amt"] }}</td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last">{{ item["pndg_amt"] }}</td>
                </tr>
              </tbody>
              <tfoot *ngIf="end">
                <tr>
                  <td colspan="2">Total</td>
                  <td colspan="2">
                    Total No of Advt :
                    {{ this.inDetailsRegReportTotal.total_advt }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ this.inDetailsRegReportTotal.advt_total }}</td>
                  <td>{{ this.inDetailsRegReportTotal.net_amt }}</td>
                  <td>{{ this.inDetailsRegReportTotal.gst }}</td>
                  <td>{{ this.inDetailsRegReportTotal.total_amt }}</td>
                  <td>{{ this.inDetailsRegReportTotal.rcvd_amt }}</td>
                  <td></td>
                  <td>{{ this.inDetailsRegReportTotal.pndg_amt }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="showindetailoffrep">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>
          <div *ngFor="let data of inDetailsRegReportsubTotalData; let s = index; let end = last">
            <table class="table table-bordered">
              <thead *ngIf="s == 0">
                <tr>
                  <th colspan="3">Vivek Saptahik</th>
                  <th colspan="3">Advt. Registreation Report</th>
                  <th colspan="2"></th>
                  <th colspan="4">Office Represantativewise</th>
                  <th colspan="2">In Detail</th>
                  <th colspan="4">Date :</th>
                </tr>
                <tr>
                  <th colspan="3">Date. From :</th>
                  <th>To :</th>
                  <th colspan="3">Issue/Grantha Categary :</th>
                  <th colspan="2">Issue Date :</th>
                  <th colspan="6">Issue Name :</th>
                  <th colspan="3">Page No</th>
                </tr>
                <tr>
                  <th>Issue Sr. No</th>
                  <th>Booking Date</th>
                  <th>Booking No</th>
                  <th>Advertiser Name</th>
                  <th>Customer Name</th>
                  <th>Representative Name</th>
                  <th>Mobile No</th>
                  <th>Office Represantative Name</th>
                  <th>RO Number</th>
                  <th>Instruction</th>
                  <th>Advt.Size</th>
                  <th>Advt Amount Rs</th>
                  <th>Net Amount</th>
                  <th>GST 5%</th>
                  <th>Total Amount</th>
                  <th>Received Amount</th>
                  <th>Receipt No. and Date</th>
                  <th>Pending Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="i == 0" colspan="3">Office Represantativewise</td>
                  <td *ngIf="i == 0">{{ item['off_rep_name'] }}</td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                </tr>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="i == 0">Represantativewise</td>
                  <td *ngIf="i == 0">{{ item['rep_name'] }}</td>
                  <td *ngIf="i == 0">{{ item['rep_mob_no'] }}</td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0"></td>
                  <td *ngIf="i == 0">
                  </td>
                  <td *ngIf="i == 0"></td>
                </tr>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="!last">{{ i + 1 }}</td>
                  <td *ngIf="!last">{{ item['booking_date'] | date:"dd-MM-yyy" }}</td>
                  <td *ngIf="!last">{{ item['booking_no'] }}</td>
                  <td *ngIf="!last">{{ item['advt_name'] }}</td>
                  <td *ngIf="!last">{{ item['cust_name'] }}</td>
                  <td *ngIf="!last"></td>
                  <td *ngIf="!last"></td>
                  <td *ngIf="!last"></td>
                  <td *ngIf="!last">{{ item['ro_no'] }}</td>
                  <td *ngIf="!last">{{ item['instruction'] }}</td>
                  <td *ngIf="!last">{{ item['advtsize'] }}</td>
                  <td *ngIf="!last">{{ item['advt_amt'] }}</td>
                  <td *ngIf="!last">{{ item['total_amount'] }}</td>
                  <td *ngIf="!last">{{ toInt(item['sgst']) + toInt(item['cgst']) }}</td>
                  <td *ngIf="!last">{{ item['amount'] }}</td>
                  <td *ngIf="!last">{{ item['part_pymt_amt'] }}</td>
                  <td *ngIf="!last">{{ item['rep_rcpt_no'] }}<br />
                    {{ item['rcpt_date'] | date:"dd-MM-yyy" }}</td>
                  <td *ngIf="!last">{{ item['part_pymt_remaning_amt'] }}</td>
                </tr>
                <tr *ngFor="let item of data; let i = index; let last = last">
                  <td *ngIf="last" colspan="2">Total</td>
                  <td *ngIf="last" colspan="2">
                    Total No of Advt : {{ item["total_advt"] }}
                  </td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last">{{ item["advt_total"] }}</td>
                  <td *ngIf="last">{{ item["net_amt"] }}</td>
                  <td *ngIf="last">{{ item["gst"] }}</td>
                  <td *ngIf="last">{{ item["total_amt"] }}</td>
                  <td *ngIf="last">{{ item["rcvd_amt"] }}</td>
                  <td *ngIf="last"></td>
                  <td *ngIf="last">{{ item["pndg_amt"] }}</td>
                </tr>
              </tbody>
              <tfoot *ngIf="end">
                <tr>
                  <td colspan="2">Total</td>
                  <td colspan="2">
                    Total No of Advt : {{ this.inDetailsOffRegReportTotal.total_advt }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ this.inDetailsOffRegReportTotal.advt_total }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.net_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.gst }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.total_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.rcvd_amt }}</td>
                  <td></td>
                  <td>{{ this.inDetailsOffRegReportTotal.pndg_amt }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="showdatewisevrybrfly">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="3">Vivek Saptahik</th>
                <th colspan="4">Advt. Registreation Report-</th>
                <th>Datewise</th>
                <th>Very Brief</th>
              </tr>
              <tr>
                <th colspan="3">Date. From :</th>
                <th>To :</th>
                <th colspan="3">Advt. Registreation Report-</th>
                <th>Issue Date :</th>
                <th>Issue Name :</th>
              </tr>
              <tr>
                <th></th>
                <th>Booking Date</th>
                <th>Total No of Advt</th>
                <th>Advt Amount Rs</th>
                <th>Net Amount</th>
                <th>GST 5%</th>
                <th>Total Amount</th>
                <th>Received Amount</th>
                <th>Pending Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of inDetailsRegReportsubTotalData">
                <td></td>
                <td>{{ item["date"] | date : "dd-MM-yyy" }}</td>
                <td>{{ item["total_advt"] }}</td>
                <td>{{ item["advt_total"] }}</td>
                <td>{{ item["net_amt"] }}</td>
                <td>{{ item["gst"] }}</td>
                <td>{{ item["total_amt"] }}</td>
                <td>{{ item["rcvd_amt"] }}</td>
                <td>{{ item["pndg_amt"] }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td colspan="2">
                  Total No of Advt :
                  {{ this.inDetailsRegReportTotal.total_advt }}
                </td>
                <td>{{ this.inDetailsRegReportTotal.advt_total }}</td>
                <td>{{ this.inDetailsRegReportTotal.net_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.gst }}</td>
                <td>{{ this.inDetailsRegReportTotal.total_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.rcvd_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.pndg_amt }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </mat-card>

      <mat-card *ngIf="showoffrepvrybrfly">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>
          <div *ngFor="let item of inDetailsRegReportsubTotalData; let i = index; let last = last">
            <table class="table table-bordered">
              <thead *ngIf="i == 0">
                <tr>
                  <th colspan="3">Vivek Saptahik</th>
                  <th colspan="3">Advt. Registreation Report-</th>
                  <th colspan="2">Office Represantativewise</th>
                  <th>Very Brief</th>
                </tr>
                <tr>
                  <th colspan="3">Date. From :</th>
                  <th>To :</th>
                  <th colspan="3">Advt. Registreation Report-</th>
                  <th>Issue Date :</th>
                  <th>Issue Name :</th>
                </tr>
                <tr>
                  <th colspan="2">Represantative Name</th>
                  <th>Total No of Advt</th>
                  <th>Advt Amount Rs</th>
                  <th>Net Amount</th>
                  <th>GST 5%</th>
                  <th>Total Amount</th>
                  <th>Received Amount</th>
                  <th>Pending Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngIf="i == 0">
                  <td colspan="3">Office Represantativewise</td>
                  <td>{{ item['off_rep_name'] }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2">{{ item['rep_name'] }}</td>
                  <td>{{ item["total_advt"] }}</td>
                  <td>{{ item["advt_total"] }}</td>
                  <td>{{ item["net_amt"] }}</td>
                  <td>{{ item["gst"] }}</td>
                  <td>{{ item["total_amt"] }}</td>
                  <td>{{ item["rcvd_amt"] }}</td>
                  <td>{{ item["pndg_amt"] }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
              <tfoot *ngIf="last">
                <tr>
                  <td>Total</td>
                  <td colspan="2">Total No of Advt : {{ this.inDetailsOffRegReportTotal.total_advt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.net_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.net_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.gst }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.total_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.rcvd_amt }}</td>
                  <td>{{ this.inDetailsOffRegReportTotal.pndg_amt }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>3<br>
        Advt.Contract<br>
        Register
      </ng-template>
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="contractDetailsForm">
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Contract Received Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerr">
                <input matStartDate formControlName="start" placeholder="Start date" [min]="financialYearMin"
                  [max]="financialYearMax" />
                <input matEndDate formControlName="end" placeholder="End date" 
                  (dateChange)="getChangedDateContract()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerr"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerr></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->


            <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContract()" />
              </div>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySelc1 (selectionChange)="getContractRepName($event)" formControlName="rep_name" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionc1()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySelc2 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
                multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionc2()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{  item['off_rep_name'] }}">{{
                  item["off_rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Advertiser Name : </mat-label>
              <mat-select #mySelc3 (selectionChange)="getContractAdvtName($event)" formControlName="advt_name" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionc3()">All</mat-option>
                <mat-option *ngFor="let item of contractAdvtName" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="indetailcontract">In Detail
                </mat-option>
                <mat-option value="briefly">Briefly
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractoneReport()">Search</button>
            </div>
          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Contract No</th>
                <th>Contract Date</th>
                <th>Advt. Name</th>
                <th>Rep. Name</th>
                <th>Off. Rep. Name</th>
                <th>Previous Balance</th>
                <th>Pre + Curr</th>
                <th>Contract Amount</th>
                <th>Discount</th>
                <th>Net Amount</th>
                <th>GST</th>
                <th>Total</th>
                <th>Contract from</th>
                <th>Contract to</th>
                <th>Booking Advt. Amount</th>
                <th>Balance Amount</th>
                <th>Instruction</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of contractData">
                <td>{{ item['contract_no'] }}</td>
                <td>{{ item['contract_date'] }}</td>
                <td>{{ item['advt_name'] }}</td>
                <td>{{ item['rep_name'] }}</td>
                <td>{{ item['off_rep_name'] }}</td>
                <td>{{ item['contract_prev_bal'] }}</td>
                <td>
                  {{ (+item['contract_prev_bal'] || 0) + (+item['contract_amt'] || 0) }}
                </td>
                <td>{{ item['contract_amt'] }}</td>
                <td>{{ item['contract_discnt_amt'] }}</td>
                <td>{{ item['contract_net_amt'] }}</td>
                <td>{{ item['contract_net_gst_amt'] }}</td>
                <td>{{ item['contract_net_total'] }}</td>
                <td>{{ item['contract_period_from'] | date:"dd-MM-yyy" }}</td>
                <td>{{ item['contract_period_to'] | date:"dd-MM-yyy" }}</td>
                <td>{{ item['contract_bkng_advt_amt'] }}</td>
                <td>{{ item['contract_bal_amt'] }}</td>
                <td>{{ item['instruction'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab>

    <!-- Create Occassional -->
    <mat-tab>
      <ng-template mat-tab-label>4<br>
        Prasiddhi<br>
        Patrak<br>
      </ng-template>
      <!-- <mat-form-field style="margin-top: 5%; margin-left: 3%">
        <mat-label>Advt. Received Date</mat-label>
        <mat-date-range-input [formGroup]="PrasiddhipatrakRange" [rangePicker]="pickerppatrak">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date"
            (dateChange)="getChangedDatePrasiddhiPatrak()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="pickerppatrak"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerppatrak></mat-date-range-picker>
        <mat-error *ngIf="
                  PrasiddhipatrakRange.controls.start.hasError(
                    'matStartDateInvalid'
                  )
                ">Invalid start date
        </mat-error>
        <mat-error *ngIf="
                  PrasiddhipatrakRange.controls.end.hasError('matEndDateInvalid')
                ">Invalid end date
        </mat-error>
      </mat-form-field> -->


      <mat-form-field [formGroup]="PrasiddhipatrakRange" appearance="outline" style="width: 30%; margin-top: 5%;">
        <mat-label>Enter Date</mat-label>

        <div class="date-inline">
          <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
          <span class="dash"> - </span>
          <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
            (blur)="getChangedDatePrasiddhiPatrak()" />
        </div>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%">
        <mat-label>Issue/grantha : </mat-label>
        <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
          <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

          <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
            {{ item.category }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%; width: 32%">
        <mat-label>Issue Dates : </mat-label>
        <mat-select (selectionChange)="getAdvtDatesPrasiddhiPatrak($event)" formControlName="issueDates" multiple
          required>
          <mat-option value="ALL">All</mat-option>
          <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] | date :
            "dd/MM/yyyy" }}
            {{ item["issueName"] }}

          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{
                                [
                                  item['issueDate'] | date : 'dd/MM/yyyy',
                                  item['issueName']'
                                ]
                              }}">{{ item["issueDate"] | date :
            "dd/MM/yyyy" }}
            {{ item["issueName"] }} 
          </mat-option> -->

      <!-- <mat-form-field style="margin-left: 3%">
        <mat-label>Advt Name : </mat-label>
        <mat-select #mySel1 (selectionChange)="getAdvtName($event)" multiple>
          <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
          <mat-option *ngFor="let item of pp_advt_names" value="{{  item['advt_name'] }}">{{ item["advt_name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field style="margin-left: 3%">
        <mat-label>Advertiser Name :</mat-label>
        <input #myInput matInput (keyup)="getAdvtNames($event)" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (onSelectionChange)="selected_name1($event, option)"
            *ngFor="let option of filteredOptions | async" [value]="option['name']">
            {{ option["name"] }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- <mat-form-field style="margin-left: 3%">
        <mat-label>Representative : </mat-label>
        <mat-select #mySel1 (selectionChange)="getRepName2($event)" multiple>
          <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
          <mat-option *ngFor="let item of pp_rep_names" value="{{  item['rep_name'] }}">{{ item["rep_name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->


      <mat-form-field style="margin-left: 3%;">
        <mat-label>Representative : </mat-label>
        <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
          <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
          <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%">
        <mat-label>Office Representative : </mat-label>
        <mat-select #mySel1 (selectionChange)="getOfficeRep1($event)" multiple>
          <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
          <mat-option *ngFor="let item of pp_off_rep_names" value="{{ item['off_rep_name'] }}">{{
            item["off_rep_name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%">
        <mat-label>Select Pagewise</mat-label>
        <mat-select (selectionChange)="getPagewise($event)" formControlName="pagetype">
          <mat-option value="pageno">पान नंबर भरलेले
          </mat-option>
          <mat-option value="nopageno">पान नंबर न भरलेले
          </mat-option>
          <mat-option value="ALL">एकत्रित
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%">
        <mat-label>Select AmtWise</mat-label>
        <mat-select (selectionChange)="getAmtwise($event)" formControlName="pagetype">
          <mat-option value="rakkam">रक्कम
          </mat-option>
          <mat-option value="norakkam">विना रक्कम
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="margin-left: 3%">
        <mat-label>Select TikkWIse</mat-label>
        <mat-select (selectionChange)="gettikwise($event)" formControlName="tiktype">
          <mat-option value="tikk">Tikk
          </mat-option>
          <mat-option value="notikk">Without Tikk
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field style="margin-left: 3%">
        <mat-label>Report Type</mat-label>
        <mat-select (selectionChange)="getReportType($event)">
          <mat-option value="Report">Report
          </mat-option>
          <mat-option value="Browse">Browse
          </mat-option>
          <mat-option value="Address">Advt Address
          </mat-option>
          <mat-option value="AddressList"> Advt Address List
          </mat-option>
          <mat-option value="Represantative">Represantative Address
          </mat-option>
          <mat-option value="RepresantativeList">Represantative Address List
          </mat-option>
        </mat-select>
      </mat-form-field>


      <button style="margin-left: 3%" (click)="getPrasiddhiPatrak()" mat-raised-button color="primary">
        Search
      </button>

      <!-- <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <button type="button" (click)="exportexcel('advt_prasiddhi_patrak')" class="btn btn-danger">
            Export
          </button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नोंदणी क्र.</th>
                <th>जाहिरातदार</th>
                <th>ग्राहकाचे नाव</th>
                <th>जाहि.आकार</th>
                <th>जाहि. सूचना</th>
                <th>पृष्ठ क्र.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let advt of this.prasiddhiPatrak; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ advt["advt_id"] }}</td>
                <td>{{ advt["advt_person_name"] }}</td>
                <td>{{ advt["cust_name"] }}</td>
                <td>{{ advt["advt_size"] }}</td>
                <td>{{ advt["comment"] }}</td>
                <td>{{ advt["advt_page"] || "--" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label> 5<br>
        Advt.Pending<br>
        Credit Voucher
      </ng-template>
      <form [formGroup]="PendingCreditVoucher">
        <div class="add-new-subscriber mat-elevation-z4">
          <button class="noPrint" style=" margin-left: 1%; margin-top: 2%;" mat-raised-button color="primary"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            print
          </button>
          <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;margin-top: 50px;">
            <mat-label>Advt. Receipt Date</mat-label>

            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getChangedDateContractpending()" />
            </div>
          </mat-form-field>
          <div style="margin-top: 20px" class="tableFixHead" id="print-section">
            <table class="table table-striped text-center ">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Sr.No.</th>

                  <th>Voucher No.</th>
                  <th>Voucher Date</th>
                  <th>Entry Date</th>
                  <th>Rep.Name</th>
                  <th>Advt.Name</th>
                  <th>Amount</th>
                  <th>Remaining Amount</th>
                  <th>Cheque no</th>
                  <th>Cheque date</th>
                  <th>Branch Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of (getallVouchersData || []); let i = index">
                  <td>
                    <button type="button" class="btn btn-danger btn-sm" (click)="displayItemId(book);">
                      Mark as Completed
                    </button>
                  </td>
                  <td>{{ i + 1 }}</td>

                  <td>{{ book["voucher_no"] }}</td>
                  <td>{{ book["voucher_date"] }}</td>
                  <td>{{ book["entry_date"]}}</td>
                  <td>{{ book["rep_name"] }}</td>
                  <td>{{ book["advtName"] }}</td>
                  <td>{{ book["price"] }}</td>
                  <td>{{ book['remaining_amt'] }}</td>
                  <td>{{ book["cheque_no"] }}</td>
                  <td>{{ book["chequeDate"] | date : "dd-MM-yyy" }}</td>
                  <td>{{ book["branch_name"] }}</td>

                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td>{{getallVouchersData?.length || ''}}</td>

                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{totalTotal | number:'1.2-2' }}</td>
                  <td>{{pendingTotal | number:'1.2-2' }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </form>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>6 <br>
        Advt Payment<br>
        Receipt
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="advtpymtrecptform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Voucher No</mat-label>
              <input matInput type="text" formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" [min]="financialYearMin" [max]="financialYearMax"
                readonly />
            </mat-form-field>

          </div>
          <div class="form-row">
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordel($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" formControlName="recptdate" readonly />
            </mat-form-field> -->
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 17%">
              <mat-label>Receipt Date</mat-label>
              <input matInput formControlName="recptdate" required />
              <!-- <mat-datepicker-toggle matSuffix [for]="pickerR1"></mat-datepicker-toggle>
              <mat-datepicker #pickerR1></mat-datepicker> -->
            </mat-form-field>

          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="repname" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="recptno" readonly />
            </mat-form-field>
            <!-- <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No (delete)</mat-label>
              <input matInput type="text" formControlName="recptno"  />
            </mat-form-field> -->
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No (delete)</mat-label>
              <mat-select formControlName="recptno">
                <mat-option *ngFor="let receipt of getdeleterecipt" [value]="receipt.rcpt_no" readonly>
                  {{ receipt.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>Credit Voucher Amount</mat-label>
              <input matInput type="number" formControlName="crdtvamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput type="number" formControlName="seamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Balance Amount</mat-label>
              <input matInput type="number" formControlName="balamt" readonly />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advt. Name</mat-label>
              <input matInput type="text" formControlName="advtname" readonly />
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field class="example-full-width" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advt. Name Search</mat-label>
              <input matInput formControlName="advtnamesearch" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto1" />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-right: 3%">
              <mat-label>Advertiser Name :</mat-label>
              <input matInput formControlName="advtnamesearch" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>    -->
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%" (click)="searchAdvtName1()">
              Search
            </button>
          </div>
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>Invoice Date</th>
                  <th>Invoice No</th>
                  <th>Booking No</th>
                  <th>Advt. Name</th>
                  <th>Invoice Amt</th>
                  <th>Receive Amt</th>
                  <th>Remaining Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of getentrybyrepnamelist ">

                  <td>{{ book.invoice_date | date: "dd-MM-yyy" }}</td>
                  <td>{{ book["invoice_no"] }}</td>
                  <td>{{ book["booking_no"] }}</td>
                  <td>{{ book["advt_name"] }}</td>
                  <td>{{ book["pay_amt"] }}</td>
                  <td>{{ book["rcv_amt"] || 0}}</td>
                  <td>{{ (book["pay_amt"] - book["rcv_amt"]).toFixed(2) || "0.00" }}</td>
                  <td style="display: flex;">
                    <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                      (click)="selectedItem(book)">
                      Select
                    </button>
                    <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(book)">
                      Update
                    </button>

                    <!-- <button mat-icon-button matTooltip="View" class="btn-sm btn-outline-primary"
                        (click)="viewAdvtInvoice(data.id)"><mat-icon>visibility</mat-icon></button>
                     
                      <button mat-icon-button matTooltip="Cancel" class="btn-sm btn-outline-danger"
                        (click)="cancelAdvtInvoice(data['id'])"><mat-icon>delete</mat-icon></button> -->

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group" style="display: flex; justify-content: center;">
            <button style="
                      width: 60%;
                      margin-top: 20px;" [disabled]="advtpymtrecptform.invalid" type="button" mat-raised-button
              color="primary" class="btn btn-primary btn-block" (click)="addadvtpymtrcpt()">
              Add
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label> 7<br>
        Advt. Payment<br>
        Receipt Register
      </ng-template>
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="PaymentReceiptRegister">
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Receipt Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrPR">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM1()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrPR"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrPR></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->

            <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;">
              <mat-label>Advt. Receipt Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM1()" />
              </div>
            </mat-form-field>


            <mat-form-field style="margin-left: 3%;width: 35%;">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
                multiple>
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{  item['off_rep_name'] }}">{{
                  item["off_rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
                  date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetail">In Detail
                </mat-option>
                <mat-option value="briefly1">Briefly
                </mat-option>
                <mat-option value="Monthwise">Monthwise
                </mat-option>
                <mat-option value="InDetail-Officer">InDetail-Officer
                </mat-option>
                <mat-option value="Briefly-Officer">Briefly-Officer
                </mat-option>
                <mat-option value="VeryBriefly-Officer">VeryBriefly-Officer
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- New Div For Issue Date Start-->

            <!-- <mat-form-field style="margin-left: 3%">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtPaymentDates($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
                  date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- End Issue Date Tab-->

            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReportPRR()">Search</button>
            </div>
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="opentworeceipt()">Print</button>
            </div>

          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    (change)="selectall($event)">
                  </mat-checkbox>
                </th>
                <th>Receipt No</th>
                <th>Receipt Date</th>
                <th>Entry Date</th>
                <th>Advt. Name</th>
                <th>Rep. Name</th>
                <th>Off. Rep. Name</th>
                <th>Issue Name</th>
                <th>Issue Date</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Net Amount</th>
                <th>Received Amount</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of advtPaymentRegiInDetailsFormBeans">

                <tr>
                  <td>
                    <mat-checkbox [(ngModel)]="item.is_selected" color="primary" (change)="copydata1(item, $event)">
                    </mat-checkbox>
                  </td>
                  <td>{{ item['rcpt_no'] }}</td>
                  <td>{{ item['rcpt_date'] }}</td>
                  <td>{{ item['entry_date'] }}</td>
                  <td>{{ item['advt_name'] }}</td>
                  <td>{{ item['rep_name'] }}</td>
                  <td>{{ item['off_rep_name'] }}</td>
                  <td>{{ item['DS_ISSUENAME'] }}</td>
                  <td>{{ item['DS_ISSUEDATE'] }}</td>
                  <td>{{ item["advt_invoice_no"] }}</td>
                  <td>{{ item["advt_invoice_date"] }}</td>
                  <td>{{ item['net_amt'] }}</td>
                  <td>{{ item['rcv_amt'] }}</td>
                  <td>
                    <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(item)">
                      Update
                    </button>

                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%;"
                      (click)="deletePymtreceipt(item['id'])"><mat-icon>delete</mat-icon></button>
                  </td>

                </tr>
              </ng-container>

            </tbody>

          </table>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>8<br>
        Advt<br>
        Invoice
      </ng-template>
      <mat-card class="card">
        <form [formGroup]="advtbillForm">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssuesAdvtNames($event)" (change)="withoutpagenopatrak()"
                formControlName="issuename" required>
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 20px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue Dates : </mat-label>
              <mat-select #mySel4 (selectionChange)="getAdvtNameDates($event)" (change)="withoutpagenopatrak()"
                formControlName="issuedate" multiple required>
                <!-- <mat-option value="" (click)="toggleAllSelection4()">All</mat-option> -->
                <mat-option *ngFor="let item of getMagIssueDatesandAdvtNames" value="{{ item['id'] }}">{{
                  item["issueDate"] | date : "dd-MM-yyyy" }}
                  {{ item["issueName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Advt. Name : </mat-label>
              <mat-select #isn (selectionChange)="getISN($event)" multiple required formControlName="advt_name">
                <mat-option value="all" (click)="toggleAllSelectionISN()">All</mat-option>
                <mat-option *ngFor="let item of advtInvoiceNames" value="{{ item['advt_name'] }}">
                  {{ item["advt_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelinvoice($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%;width: 40%" class="example-full-width" appearance="outline">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="picker8" formControlName="date" (dateChange)="advtInvoiceDate($event)"
                required />
              <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
              <mat-datepicker #picker8 [dateFilter]="dateFilter"></mat-datepicker>
            </mat-form-field>

            <mat-form-field *ngIf="!deleterec" style="margin-left: 20px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Bill No :</mat-label>
              <input type="text" formControlName="billno" matInput required readonly />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" style="margin-left: 20px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Bill No (deleted) :</mat-label>
              <mat-select formControlName="billno" required>
                <mat-option *ngFor="let bill of getdeletereciptinvoice" [value]="bill.rcpt_no">
                  {{ bill.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <button style="margin-left: 100px; width: 70%; margin-top: 10px" class="p-4" type="submit"
              [disabled]="advtbillForm.invalid" (click)="openAdvtBill()" mat-raised-button color="primary">
              Add Advt Bill
            </button>

            <button class="p-2" style="margin-left:30px; width: 15%;" (click)="withoutpagenopatrak()" mat-raised-button
              color="primary">Search</button>
          </div>
        </form>
      </mat-card>

      <mat-card class="card1">
        <h2 style="text-align:center">List of Advt Invoice</h2>

        <div>
          <form [formGroup]="advtbillFormsecond" style="display: flex; align-items: flex-end; gap: 12px;">

            <!-- Date Range Field -->
            <mat-form-field appearance="outline" style="width: 25%;">
              <mat-label>Enter Date</mat-label>
              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM11()" />
              </div>
            </mat-form-field>

            <!-- Representative Multi-select -->
            <mat-form-field style="margin-left: 3%;width: 35%;">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <!-- NEW: With/Without Zero Dropdown -->
            <mat-form-field style="width: 20%;">
              <mat-label>मागील बाकी</mat-label>
              <mat-select formControlName="zeroFilter">
                <mat-option value="without">मागील बाकी येणे</mat-option>
                <mat-option value="with">मागील बाकी न येणे</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Search Button -->
            <button mat-raised-button color="primary" (click)="getAllAdvtInovicesData()"
              style="margin-left:30px; width: 15%;margin-bottom: 40px;">
              Search
            </button>
          </form>
        </div>

        <!-- Table Section -->
        <div class="tableFixHead">
          <button [ngStyle]="{'display':allSelectedtable || someComplete() ? 'block' : 'none'}" style="float: right;"
            mat-raised-button class="btn btn-primary" (click)="printAdvtInvoice()">Print Invoices</button>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    [indeterminate]="someComplete()" (change)="setAll($event.checked)">
                  </mat-checkbox>
                </th>
                <th>Sr. No.</th>
                <th>Invoice No.</th>
                <th>Invoice Date</th>
                <th>Rep. Name</th>
                <th>Advt. Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of advtInvoiceList; let i=index">
                <td>
                  <mat-checkbox [(ngModel)]="data.is_selected" color="primary" (ngModelChange)="updateAllComplete()">
                  </mat-checkbox>
                </td>
                <td>{{ i+1 }}</td>
                <td>{{ data['invoice_no'] }}</td>
                <td>{{ data['invoice_date'] }}</td>
                <td>{{ data['rep_name'] }}</td>
                <td>{{ data['advt_name'] }}</td>
                <td>
                  <button mat-icon-button matTooltip="View" class="btn-sm btn-outline-primary"
                    (click)="viewAdvtInvoice(data.id)"><mat-icon>visibility</mat-icon></button>

                  <button mat-icon-button matTooltip="Cancel" class="btn-sm btn-outline-danger"
                    (click)="cancelAdvtInvoice(data['id'])"><mat-icon>delete</mat-icon></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card class="card">
        <style>
          /* Card styling */
          .card {
            margin: 20px;
            padding: 20px;
            box-shadow: 0 4px 8px rgba(239, 242, 243, 0.1);
            border-radius: 8px;
          }

          /* Table responsive wrapper */
          .table-responsive {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }

          /* Table styling */
          .table {
            width: 100%;
            margin-bottom: 1rem;
            background-color: transparent;
            border-collapse: collapse;
          }

          .table th,
          .table td {
            padding: 12px;
            vertical-align: middle;
            border-top: 1px solid #dee2e6;
            white-space: nowrap;
            font-size: 14px;
          }

          .table thead th {
            vertical-align: bottom;
            border-bottom: 2px solid #dee2e6;
            background-color: #a4e8f1;
            color: black;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.5px;
          }

          .table tbody tr:hover {
            background-color: #f8f9fa;
          }

          .table-striped tbody tr:nth-of-type(odd) {
            background-color: rgba(245, 246, 247, 0.05);
          }

          /* Form controls */
          .form-control-sm {
            height: calc(1.5em + 0.5rem + 2px);
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            border-radius: 0.2rem;
            border: 1px solid #ced4da;
          }

          .form-control-sm:focus {
            border-color: #80bdff;
            outline: 0;
            box-shadow: 0 0 0 0.2rem rgba(217, 227, 238, 0.25);
          }

          /* Button styling */
          .btn-sm {
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            border-radius: 0.2rem;
            display: inline-flex;
            align-items: center;
            gap: 4px;
          }

          .btn-outline-info {
            color: #17a2b8;
            border-color: #17a2b8;
            background-color: transparent;
          }

          .btn-outline-info:hover {
            color: #fff;
            background-color: #17a2b8;
            border-color: #17a2b8;
          }

          /* Material icon in button */
          .btn mat-icon {
            font-size: 16px;
            width: 16px;
            height: 16px;
          }

          /* Responsive design */
          @media (max-width: 768px) {
            .card {
              margin: 10px;
              padding: 15px;
            }

            .table th,
            .table td {
              padding: 8px;
              font-size: 12px;
            }

            .table th {
              font-size: 10px;
            }
          }

          @media (max-width: 576px) {
            .card {
              margin: 5px;
              padding: 10px;
            }

            .table th,
            .table td {
              padding: 6px;
              font-size: 11px;
            }

            .form-control-sm {
              width: 60px !important;
              font-size: 11px;
            }
          }

          /* Loading state */
          .text-center {
            text-align: center;
          }

          .text-muted {
            color: #6c757d;
          }

          .p-4 {
            padding: 1.5rem;
          }

          /* Additional improvements */
          .table-container {
            max-height: 600px;
            overflow-y: auto;
          }

          /* Sticky header (optional) */
          .table-sticky-header thead th {
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #343a40;
          }
        </style>
        <h2 style="text-align:center">List without page no</h2>

        <!-- Responsive table wrapper -->
        <div class="table-responsive">
          <div class="tableFixHead">
            <table class="table table-striped table-hover">
              <thead class="table-dark">
                <tr>
                  <th scope="col">Sr</th>
                  <th scope="col">Advt ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Representative Name</th>
                  <th scope="col">Office Representative Name</th>
                  <th scope="col">Booking Date</th>
                  <th scope="col">Booking No</th>
                  <th scope="col">Issue Name</th>
                  <th scope="col">Issue Date</th>
                  <th scope="col">Advt Size</th>
                  <th scope="col">Page</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of PPwithoutnumber; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{data.DS_ADVTID}}</td>
                  <td>{{data.name}}</td>
                  <td>{{data.rep_name}}</td>
                  <td>{{data.off_rep_name}}</td>
                  <td>{{data.booking_date | date : "dd-MM-yyy"}}</td>
                  <td>{{data.booking_no}}</td>
                  <td>{{data.DS_ISSUENAME}}</td>
                  <td>{{data.DS_ISSUEDATE}}</td>
                  <td>{{data.DS_advtsize}}</td>
                  <td>
                    <input [(ngModel)]="data.pages_no" class="form-control form-control-sm" style="width: 60px;"
                      type="number" min="1" />
                  </td>
                  <td>
                    <button type="button" class="btn btn-sm btn-outline-info" matTooltip="Add"
                      [disabled]="!data.pageNo || data.pageNo === 0" (click)="addpageno(data)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Loading state -->
        <div *ngIf="!PPwithoutnumber || PPwithoutnumber.length === 0" class="text-center p-4">
          <p class="text-muted">No data available</p>
        </div>

      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>9<br>
        Advt<br>
        Invoice Register
      </ng-template>
      <mat-card class="card">
        <form [formGroup]="advtinvoiceForm" class="form-grid">

          <!-- Row 1 -->
          <!-- <mat-form-field appearance="outline">
            <mat-label>Select Date</mat-label>
            <mat-date-range-input [formGroup]="advtinvoiceForm" [rangePicker]="advtInvoiceR">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date"
                (dateChange)="getChangedDateAdvtInvoice()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="advtInvoiceR"></mat-datepicker-toggle>
            <mat-date-range-picker #advtInvoiceR></mat-date-range-picker>

            <mat-error *ngIf="advtinvoiceForm.controls.start.hasError('matStartDateInvalid')">
              Invalid start date
            </mat-error>
            <mat-error *ngIf="advtinvoiceForm.controls.end.hasError('matEndDateInvalid')">
              Invalid end date
            </mat-error>
          </mat-form-field> -->

          <mat-form-field appearance="outline">
            <mat-label>Advt. Invoice Date</mat-label>

            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (blur)="getChangedDateAdvtInvoice()" />
            </div>
          </mat-form-field>


          <mat-form-field appearance="outline">
            <mat-label>Office Representative</mat-label>
            <mat-select (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of pp_off_rep_names" [value]="item.off_rep_name">
                {{ item.off_rep_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Row 2 -->
          <mat-form-field style="margin-left: 3%;width: 95%;">
            <mat-label>Representative : </mat-label>
            <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
              <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
              <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Issue/Grantha</mat-label>
            <mat-select (selectionChange)="getIssuesAdvtNames($event)" formControlName="issuename" required>
              <mat-option *ngFor="let item of advtCategorylist" [value]="item.category">
                {{ item.category }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Issue Dates</mat-label>
            <mat-select (selectionChange)="getAdvtNameDates($event)" formControlName="issuedate" multiple required>
              <mat-option *ngFor="let item of getMagIssueDatesandAdvtNames" [value]="item.id">
                {{ item.issueDate | date : "dd-MM-yyyy" }} - {{ item.issueName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Row 3 -->
          <mat-form-field appearance="outline">
            <mat-label>Report Type</mat-label>
            <mat-select (selectionChange)="getAdvtInvoiceReportType($event)">
              <mat-option value="In Detail">In Detail</mat-option>
              <mat-option value="Briefly">Briefly</mat-option>
              <mat-option value="Monthwise">Monthwise</mat-option>
              <mat-option value="Indetail-Officer">Indetail-Officer</mat-option>
              <mat-option value="Briefly-Officer">Briefly-Officer</mat-option>
              <mat-option value="VeryBriefly-Officer">VeryBriefly-Officer</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Button -->
          <div class="button-row">
            <button type="submit" (click)="openAdvtInvoiceRegister()" mat-raised-button color="primary">
              Search
            </button>
          </div>

        </form>
      </mat-card>

    </mat-tab>

    <!-- create advance stamp Receipt and Register -->
    <mat-tab>
      <ng-template mat-tab-label>10<br>
        Advt Advance<br>
        Stamp Receipt
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="advtAdvanceStampform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Today Date</mat-label>
              <input matInput type="text" formControlName="date" />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker70" (dateChange)="GenerateAdvanceStampno()"
                formControlName="recptdate" />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker70"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker70></mat-datepicker>
            </mat-form-field>

          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 5%;width: 40%;">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advance Stamp Number</mat-label>
              <input matInput type="text" formControlName="crdtvno" />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advance Stamp Number(Deleted)</mat-label>
              <mat-select formControlName="crdtvno">
                <mat-option *ngFor="let stamp of getdeleterecitstamp" [value]="stamp.rcpt_no">
                  {{ stamp.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" class="example-full-width"
              style="width: 40%; margin-left: 5%;">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto1" />
              <mat-autocomplete #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <!-- <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-right: 3%">
                <mat-label>Advertiser Name :</mat-label>
                <input matInput formControlName="advtName" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
                <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                    [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelstamp($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>

          </div>
          <div>
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%" (click)="addadvtCNrcpt1()">
              Search
            </button>
          </div>

        </form>

        <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
          <table class="table table-bordered table-hover text-center">
            <thead>
              <tr>
                <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                  (change)="selectall($event)">
                </mat-checkbox>
                <th>Invoice Date</th>
                <th>Invoice No</th>
                <th>Advt. Name</th>
                <th>Invoice Amount</th>
                <!-- <th>Amount Remaining</th> -->
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of advtCreditNote">
                <td>
                  <mat-checkbox [(ngModel)]="book.is_selected" color="primary" (change)="copydata1(book, $event)">
                  </mat-checkbox>
                </td>
                <td>{{ book.invoice_date}}</td>
                <td>{{ book["invoice_no"] }}</td>
                <td>{{ book["advt_name"] }}</td>
                <td>{{ book["advt_amt"] }}</td>
                <!-- <td>{{ book["remain_amt"] }}</td> -->
                <td style="display: flex;">
                  <!-- <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                      (click)="openAdvtBill4(book)">
                      Select
                    </button> -->
                  <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(book)">
                      Update
                    </button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group" style="display: flex; justify-content: center;">
          <button style="
                      width: 60%;
                      margin-top: 20px;
                    " type="button" mat-raised-button color="primary" class="btn btn-primary btn-block"
            (click)="openAdvtBill4()">
            Add
          </button>
        </div>

      </mat-card>

      <mat-card>
        <h1 style="padding-top: 20px; text-align: center; font-weight: 500;">Advt Stamp Receipt List</h1>

        <form [formGroup]="stampgetdata">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 30%" appearance="outline">
              <mat-label>Select Date</mat-label>
              <mat-date-range-input [rangePicker]="advtInvoiceR1">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getdateforstamp()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="advtInvoiceR1"></mat-datepicker-toggle>
              <mat-date-range-picker #advtInvoiceR1></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="outline" class="example-full-width"
              style="width: 30%; margin-left: 5%;">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto2" />
              <mat-autocomplete #auto2="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name2($event)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </form>

        <table class="table table-bordered table-hover text-center">
          <thead>
            <tr>
              <th>Sr. No</th>
              <!-- <th>Creation Date</th> -->
              <th>Receipt Date</th>
              <th>Receipt No</th>
              <th>Advt. Name</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let book of stampdata; let i = index">
              <td style="color: black;">{{i+1}}</td>
              <td style="color: black;">{{ book.receipt_date | date: "dd-MM-yyy" }}</td>
              <td style="color: black;">{{ book["receipt_no"] }}</td>
              <td style="color: black;">{{ book["advt_name"] }}</td>
              <td style="color: black;">{{ book["amt"] }}</td>
              <!-- <td>{{ book["remain_amt"] }}</td> -->
              <td style="display: block;">
                <!-- <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                    (click)="openAdvtBill4(book)">
                    Select
                  </button> -->
                <button mat-raised-button type="button" class="
              btn btn-info" (click)="opentwostampreceipt(book)">Print</button>

                <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                  (click)="deletestamp(book)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        11<br>
        Advt Advance<br>
        Stamp Register
      </ng-template>

      <mat-card style="margin-top: 30px;">
        <form [formGroup]="stampgetdata1">

          <!-- First Row: Date Range and Advertiser Name -->
          <div class="row"
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 15px 0; max-width: 900px;margin-left: 5%;">
            <!-- Date Range -->
            <mat-form-field appearance="outline">
              <mat-label>Advt.Stamp Date</mat-label>
              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax"
                  required />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (change)="getdateforstamp1()" required />
              </div>
              <mat-error *ngIf="stampgetdata1.get('start')?.hasError('required')">
                Start date is required
              </mat-error>
              <mat-error *ngIf="stampgetdata1.get('end')?.hasError('required')">
                End date is required
              </mat-error>
            </mat-form-field>

            <!-- Advertiser Name -->
            <mat-form-field appearance="outline">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto2" />
              <mat-autocomplete #auto2="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name2($event)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Second Row: Issue/Grantha and Issue Dates -->
          <div class="row"
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 15px 0; max-width: 900px;margin-left: 5%;">
            <!-- Issue/Grantha -->
            <mat-form-field appearance="outline">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename">
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Issue Dates -->
            <mat-form-field appearance="outline">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">
                  {{ item["issueDate"] | date : "dd/MM/yyyy" }} {{ item["issueName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Third Row: Representative and Office Representative -->
          <div class="row"
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 15px 0; max-width: 900px;margin-left: 5%;">
            <!-- Representative -->
            <mat-form-field appearance="outline">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{ item['rep_name'] }}">
                  {{ item["rep_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Office Representative -->
            <mat-form-field appearance="outline">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
                multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{ item['off_rep_name'] }}">
                  {{ item["off_rep_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Fourth Row: Report Type and Action Buttons -->
          <div class="row"
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 15px 0; align-items: start; max-width: 900px;margin-left: 5%;">
            <!-- Report Type -->
            <mat-form-field appearance="outline">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel3 (selectionChange)="getContractReportType($event)">
                <mat-option value="Indetail">In Detail</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Action Buttons -->
            <div style="display: flex; gap: 15px;">
              <button mat-raised-button type="button" color="primary" (click)="ShowReportAdvanceType()"
                style="flex: 1;">
                Search
              </button>

              <!-- <button mat-raised-button type="button" color="accent" (click)="opentworeceipt()" style="flex: 1;">
            Print
          </button> -->
            </div>
          </div>

        </form>

        <!-- Table -->
        <table class="table table-bordered table-hover text-center" style="margin-top: 20px;">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Receipt Date</th>
              <th>Receipt No</th>
              <th>Advt. Name</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let book of stampdata; let i = index">
              <td>{{ i+1 }}</td>
              <td>{{ book.receipt_date | date: "dd-MM-yyy" }}</td>
              <td>{{ book["receipt_no"] }}</td>
              <td>{{ book["advt_name"] }}</td>
              <td>{{ book["amt"] }}</td>
              <td style="white-space: nowrap;">
                <button mat-raised-button type="button" color="primary" (click)="opentwostampreceipt(book)">
                  Print
                </button>
                <button mat-raised-button type="button" color="warn" style="margin-left: 8px;"
                  (click)="deletestamp(book)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab>


    <!-- Advt credit note recipt -->
    <mat-tab>
      <ng-template mat-tab-label>12<br>
        Advt Credit<br>
        Note Receipt
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="advtCreditNoteform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Today Date</mat-label>
              <input matInput type="text" formControlName="date" />
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="mc" required/>
              <mat-autocomplete #mc="matAutocomplete">
                <mat-option (selectionChange)="getContractOffRepName($event )"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
            <mat-form-field class="example-full-width" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advertiser Name :</mat-label>
              <!-- formControlName="sadvtname" -->
              <input matInput formControlName="advtname" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1"
                required />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" (change)="GenerateCRno()" formControlName="recptdate"  />
            </mat-form-field> -->
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker07" (dateChange)="GenerateCRno()"
                formControlName="recptdate" required />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker07"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker07></mat-datepicker>
            </mat-form-field>


            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelcn($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno" required />
            </mat-form-field> -->


            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno" />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No(Deleted)</mat-label>
              <mat-select formControlName="crdtvno">
                <mat-option *ngFor="let cn of getdeleterecitcn" [value]="cn.rcpt_no">
                  {{ cn.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>



            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 multiple>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of getdeleterecitcn" value="{{  item['rcpt_no'] }}">{{ item["rcpt_no"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          </div>
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="creditRepName" multiple>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtnewreplistForm" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="CrNno" readonly />
            </mat-form-field> -->

          </div>
          <div class="form-group">

            <button type="button" [disabled]="!advtCreditNoteform.value.recptdate" mat-raised-button color="primary"
              style="margin-left: 5%" (click)="addadvtCNrcpt()">
              Search
            </button>
          </div>
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>Invoice Date</th>
                  <th>Invoice No</th>
                  <th>Rep Name</th>
                  <th>Advt. Name</th>
                  <th>Invoice Amount</th>
                  <th>Amount Remaining</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of advtCreditNote">
                  <td>{{ book.invoice_date }}</td>
                  <td>{{ book["invoice_no"] }}</td>
                  <td>{{ book["rep_name"] }}</td>
                  <td>{{ book["advt_name"] }}</td>
                  <td>{{ book["advt_amt"] }}</td>
                  <td>{{ book["remain_amt"] }}</td>
                  <td style="display: flex;">
                    <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                      (click)="openAdvtBill1(book)">
                      Select
                    </button>
                    <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(book)">
                      Update
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group" style="display: flex; justify-content: center;">
            <button style="
                      width: 60%;
                      margin-top: 20px;
                    " type="button" mat-raised-button color="primary" class="btn btn-primary btn-block"
              (click)="openAdvtBill3()">
              Add
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>13<br>
        Advt Credit<br>
        Note Register
      </ng-template>
      <mat-card style="padding: 30px 0px;">
        <form [formGroup]="CreditNoteForm">
          <div class="form-row">

            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrCN">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM2()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrCN"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrCN></mat-date-range-picker>

              <mat-error *ngIf="contractDetailsForm.controls.start.hasError('matStartDateInvalid')">Invalid start
                date</mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->


            <mat-form-field appearance="outline" style="margin-left: 7%; width: 30%;">
              <mat-label>Advt. Credit Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM2()" />
              </div>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%;width: 35%;">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{  item['off_rep_name'] }}">{{
                  item["off_rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Issue Categary : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtCategorylist" value="{{  item['category'] }}">{{ item["category"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field style="margin-left: 3%;width: 35%;">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
                  date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetailCreditNote">In Detail
                </mat-option>
                <mat-option value="CreditNotebriefly">Briefly
                </mat-option>
                <mat-option value="CreditMonthwise">Monthwise
                </mat-option>
                <mat-option value="InDetail-CreditOfficer">InDetail-Officer
                </mat-option>
                <mat-option value="Briefly-OfficerCredit">Briefly-Officer
                </mat-option>
                <mat-option value="VeryBriefly-CreditNote">VeryBriefly-Officer
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReport()">Search</button>
            </div>
          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    (change)="selectall($event)">
                  </mat-checkbox>
                </th>
                <th>Credit Note No</th>
                <th>CR Date</th>
                <th>Advt. Name</th>
                <th>Rep. Name</th>
                <th>Off. Rep. Name</th>
                <th>Issue Name</th>
                <th>Issue Date</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Net Amount</th>
                <th>Received Amount</th>
                <th>Remark</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of advtcreditnotetRegiInDetailsFormBeans">

                <tr>
                  <td>
                    <mat-checkbox [(ngModel)]="item.is_selected" color="primary" (change)="copydata2(item, $event)">
                    </mat-checkbox>
                  </td>
                  <td>{{ item['credit_voc_no'] }}</td>
                  <td>{{ item['voc_date'] }}</td>
                  <td>{{ item['advt_name'] }}</td>
                  <td>{{ item['rep_name'] }}</td>
                  <td>{{ item['office_rep'] }}</td>
                  <td>{{ item['DS_ISSUENAME'] }}</td>
                  <td>{{ item['DS_ISSUEDATE'] }}</td>
                  <td>{{ item["advt_invoice_no"] }}</td>
                  <td>{{ item["advt_invoice_date"] }}</td>
                  <td>{{ item['net_amt'] }}</td>
                  <td>{{ item['credit_v_amt'] }}</td>
                  <td>{{ item['remark'] }}</td>
                  <td>
                    <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(item)">
                      Update
                    </button> -->

                    <button mat-raised-button type="button" color="primary" (click)="opentwocreditreceipt(item)">
                      Print
                    </button>

                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%;"
                      (click)="deleteCreditNote(item['id'])"><mat-icon>delete</mat-icon></button>
                  </td>

                </tr>
              </ng-container>

            </tbody>

          </table>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>14<br>
        GST <br>
        Ledger
      </ng-template>
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="GSTFullReportForm" class="mt-5">
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickergst">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM4()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickergst"></mat-datepicker-toggle>
              <mat-date-range-picker #pickergst></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->


            <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;">
              <mat-label> Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM4()" />
              </div>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%;width: 35%;">
              <mat-label>Representative : </mat-label>
              <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
                <mat-option value="ALL" (click)="toggleAllSelectionr2()">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{  item['off_rep_name'] }}">{{
                  item["off_rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="GSTFullReport">GST Full Report
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="form-row">

            <!-- <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReport()">Search</button>
            </div> -->
            <div style="display: flex; justify-content: center; margin-left: 45%;">
              <button mat-raised-button type="button" class="btn btn-info"
                (click)="showContractReport()">Search</button>
            </div>

          </div>
        </form>
        <div class="tableFixHead">

        </div>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>15<br>
        Advt. <br>
        Outstanding Reports
      </ng-template>
      <mat-card style="margin-top: 2%; margin-top: 2%;height: 400px;padding-top: 30px;">
        <h3 class="text-center" style="font-size: 25px; color: black; margin-bottom: 20px;">Advt Outstanding Reports
        </h3>

        <form [formGroup]="OutStandingForm">
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerOT">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM3()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerOT"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerOT></mat-date-range-picker>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->

            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <input matInput formControlName="repname"/>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <input formControlName="repname" matInput [matAutocomplete]="autorepnames"  (keyup)="getRepNames($event)"/>
              <mat-autocomplete autoActiveFirstOption #autorepnames="matAutocomplete">
                <mat-option (onSelectionChange)="getContractRepNames($event)"
                  *ngFor="let option of filterrep" [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field appearance="outline" style="margin-left: 10%; width: 35%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM3()" />
              </div>
            </mat-form-field>


            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <input matInput formControlName="repname" [matAutocomplete]="autorepnames3" (keyup)="getRepNames($event)"
                multiple />
              <mat-autocomplete autoActiveFirstOption #autorepnames3="matAutocomplete">
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option (onSelectionChange)="getContractRepNames($event) " *ngFor="let option of filterrep"
                  [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 formControlName="offrepname" (selectionChange)="getContractOffRepName($event)"
                multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{  item['off_rep_name'] }}">{{
                  item["off_rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%;width: 15%;">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 20%; ">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
                  date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="margin-left: 10%; width: 35%;">
              <mat-label>Advertiser Name :</mat-label>
              <!-- formControlName="sadvtname" -->
              <input matInput formControlName="advtname" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let item of newadvtname"
                  value="{{  item['name'] }}">
                  {{ item["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="AdvtoutstandingInDetails">All Outstanding In Detail
                </mat-option>
                <mat-option value="AdvtoutstandingAllbriefly">All Briefly
                </mat-option>
                <mat-option value="Advtoutstandingbriefly">Very Briefly
                </mat-option>
                <mat-option value="unpaidOutstandingInDetails">Unpaid OutStanding In Detail
                </mat-option>
                <mat-option value="unpaidOutstandingbriefly">Unpaid OutStanding Briefly
                </mat-option>
                <mat-option value="unpaidOutstandingVbriefly">Unpaid OutStanding Very Briefly
                </mat-option>
                <mat-option value="creditdOutstandingindetails">Credit OutStanding In Detail
                </mat-option>
                <!-- <mat-option value="creditOutstandingbriefly">Credit OutStanding Briefly
                </mat-option> -->
                <mat-option value="AdvertisementAddress">Advt Address
                </mat-option>
                <mat-option value="AdvertisementAddressList">Advt Address List
                </mat-option>
                <mat-option value="RepresantativeAddress">Represantative Address
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">

            <div style="margin-left: 43%;margin-top: 15px;">
              <button mat-raised-button type="button" class="
              btn btn-info" color="primary" (click)="showContractReport()">Search</button>
            </div>
          </div>
        </form>
        <div class="tableFixHead">

        </div>
      </mat-card>

      <mat-card class="card">
        <h3 class="text-center" style="font-size: 25px; color: black; margin-bottom: 20px;">
          Send Reminder Letter
        </h3>

        <form class="form" [formGroup]="Sendreminderform">
          <div class="form-row">

            <!-- Date Field -->
            <mat-form-field appearance="outline" style="margin-left: 10%; width: 35%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="startDate" [min]="financialYearMin"
                  [max]="financialYearMax" />

                <span class="dash"> - </span>

                <input matInput type="date" formControlName="endDate" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateAdvtRemainder()" />
              </div>
            </mat-form-field>

            <!-- Report Type -->
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="send-reminder1">To Advertiser</mat-option>
                <mat-option value="send-reminder2">To Representative</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">

            <!-- Representative Name -->
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Representative Name :</mat-label>
              <input matInput formControlName="repname" [matAutocomplete]="autorepnames3"
                (keyup)="getRepNames($event)" />

              <mat-autocomplete autoActiveFirstOption #autorepnames3="matAutocomplete"
                (optionSelected)="getContractRepNames($event)">
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let option of filterrep" [value]="option['rep_name']">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <!-- Advertiser Name – only when send-reminder1 -->
            <mat-form-field style="margin-left: 10%; width: 35%;" *ngIf="contractReportType=='send-reminder1'">
              <mat-label>Advertiser Name :</mat-label>

              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" formControlName="advtname" multiple>
                <mat-option *ngFor="let item of newadvtname" [value]="item['name']">
                  {{ item["name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%;"
              (click)="showContractReportReminder()">
              Search
            </button>
          </div>

        </form>
      </mat-card>

    </mat-tab>

    <!-- create a business report -->

    <mat-tab>
      <ng-template mat-tab-label>16<br>
        Advt<br>
        Personal Ledger
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="PersonalNoteform">
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerpersonalledger">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM7()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerpersonalledger"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerpersonalledger></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field> -->

            <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM7()" />
              </div>
            </mat-form-field>

            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="advtNames" />
              <mat-autocomplete #advtNames="matAutocomplete">
                <mat-option (selectionChange)="getContractOffRepName($event )" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" style="width: 60%; margin-left: 5%; margin-top: 2%">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="sadvtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

          </div>
          <div class="form-row">
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno"  />
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" (change)="GenerateCRno()" formControlName="recptdate"  />
            </mat-form-field> -->
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetail-personalledger">In Detail
                </mat-option>
                <mat-option value="InDetail-personalledger1">In Detail1
                </mat-option>
                <mat-option value="briefly-personalledger">Briefly
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="showPersonalLedgerReport()">
              Search
            </button>
          </div>
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="creditRepName" multiple>
                <mat-option *ngFor="let item of advtnewreplistForm" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="CrNno" readonly />
            </mat-form-field> -->

          </div>
          <div class="form-group">


          </div>

        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>17<br>
        Pending<br>
        Commision Voucher
      </ng-template>
      <form class="form" [formGroup]="advtcommForm">

        <!-- <div style="text-align:center">
        <button type="button" mat-raised-button color="primary" style="margin-left: 5%" (click)="searchbookselname()">
          Search
        </button>

      </div> -->
        <div class="add-new-subscriber1 mat-elevation-z4">
          <button class="noPrint" style=" margin-left: 1%; margin-top: 2%;" mat-raised-button color="primary"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
          </button>
          <button class="noPrint" style="margin-top: 2%; margin-left: 1%"
            (click)="exportexcel('Pending_credit_vocuher')" mat-raised-button color="primary">
            Export
          </button>
          <mat-form-field appearance="outline" style="margin-left: 7%; width: 35%;margin-top: 50px;">
            <mat-label>Advt. Commission Date</mat-label>

            <div class="date-inline">
              <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
              <span class="dash"> - </span>
              <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                (change)="getChangedDateContractCommisionpending()" />
            </div>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; width: 35%;">
            <mat-label>Representative Name : </mat-label>
            <input matInput formControlName="repname" [matAutocomplete]="autorepnames3" (keyup)="getRepNames($event)"
              multiple />
            <mat-autocomplete autoActiveFirstOption #autorepnames3="matAutocomplete">
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

              <mat-option (onSelectionChange)="getContractRepNames($event) " *ngFor="let option of filterrep"
                [value]="option['rep_name']">
                {{ option["rep_name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead" id="print-section">
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Sr.No.</th>
                  <th>Voucher No.</th>
                  <th>Voucher Date</th>
                  <th>Entry Date</th>
                  <th>Rep.Name</th>
                  <th>Advt Name</th>
                  <th>Commission</th>
                  <th>Remaining Commission</th>
                  <th>Comm Paid date</th>



                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of getallCommVouchersData; let i = index">
                  <td>
                    <button type="button" class="btn btn-danger btn-sm"
                      (click)="displayCommItemId(book,advtcommrecptform)">
                      Mark as Completed
                    </button>
                  </td>
                  <td>{{ i + 1 }}</td>

                  <td>{{ book["voucher_no"] }}</td>
                  <td>{{ book["voucher_date"] }}</td>
                  <td>{{ book["entry_date"] }}</td>
                  <td>{{ book["rep_name"] }}</td>
                  <td>{{ book["advtName"] | slice:0:25 }}</td>
                  <td>{{ book["commission"] }}</td>
                  <td>{{ book["remaining_amt"] }}</td>
                  <td>{{ book["com_paid_date"] || '' }}</td>

                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td></td>
                  <td>{{ getallCommVouchersData.length }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ commission_Total}}</strong></td>
                  <td><strong>{{ commRemainingTotal }}</strong></td>
                </tr>
              </tfoot>

            </table>
          </div>
        </div>
      </form>
    </mat-tab>

    <mat-tab [(selectedIndex)]="demo1TabIndex1">
      <ng-template mat-tab-label>18<br>
        Advt Commision<br>
        Receipt
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="advtcommrecptform">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Voucher No</mat-label>
              <input matInput type="text" formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" [min]="financialYearMin" [max]="financialYearMax"
                readonly />
            </mat-form-field>
          </div>

          <div class="form-row">
            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelC($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>

            <mat-form-field appearance="outline" style="width: 40%; margin-left: 17%">
              <mat-label>Receipt Date</mat-label>
              <input matInput formControlName="recptdate" required />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Advt Name</mat-label>
              <input matInput type="text" formControlName="advtname" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="recptno" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No (delete)</mat-label>
              <mat-select formControlName="recptno">
                <mat-option *ngFor="let receipt of getdeleterecipt" [value]="receipt.rcpt_no" readonly>
                  {{ receipt.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>Commission Voucher Amount</mat-label>
              <input matInput type="number" formControlName="crdtvamt" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput type="number" formControlName="seamt" [value]="getGrandTotal('selectedAmount')"
                readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 12%; margin-left: 5%">
              <mat-label>TDS Percentage</mat-label>
              <input matInput type="number" formControlName="tdsPercentage" (input)="calculateTdsAmount()"
                (blur)="calculateBalanceAmount()" />
              <span matSuffix>%</span>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>TDS Amount</mat-label>
              <input matInput type="number" formControlName="tdsAmount" [value]="calculatedTdsAmount" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Balance Amount</mat-label>
              <input matInput type="number" formControlName="balamt" [value]="calculatedBalanceAmount" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Total Balance Amount</mat-label>
              <input matInput type="number" [value]="calculateTotalBalanceAmount()" readonly />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Rep. Name</mat-label>
              <input matInput type="text" formControlName="repname" readonly />
            </mat-form-field>
          </div>

          <div class="form-group">
            <div style="display: flex; align-items: center; width: 100%;">
              <!-- LEFT SIDE: Autocomplete -->
              <mat-form-field class="example-full-width" appearance="outline" style="width: 40%; margin-left: 5%">
                <mat-label>Rep. Name Search</mat-label>
                <input matInput formControlName="repnamesearch" (keyup)="getAdvtRepNames($event)"
                  [matAutocomplete]="auto90" />
                <mat-autocomplete autoActiveFirstOption #auto90="matAutocomplete">
                  <mat-option *ngFor="let option of rep_names" (onSelectionChange)="selected_name1($event, option)"
                    [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <!-- RIGHT SIDE: COMM PERCENTAGE -->
              <div style="margin-left: 200px; font-size: 18px; font-weight: bold;">
                प्रतिनीधी कमिशन - {{ comm_percentage ? comm_percentage + '%' : '' }}
              </div>
            </div>

            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="searchRepAdvtName1()">
              Search
            </button>
          </div>

          <!-- TABLE SECTION -->
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <mat-card class="mt-5">
                <table>
                  <thead>
                    <tr class="comm-head-2">
                      <th class="comm-head-2">Invoice No</th>
                      <th>Invoice <br>Date</th>
                      <th>Advt Name</th>
                      <th>Issue Name</th>
                      <th>Issue Date</th>
                      <th>Net Amount</th>
                      <th>Pending Amt</th>
                      <th>Received Amt</th>
                      <th>Commission %</th>
                      <th>Total Commission<br> Amount</th>
                      <th>Paid Commission<br> Date</th>
                      <th>Paid Commission</th>
                      <th>UnPaid Commission</th>
                      <th>Select Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody class="comm-head-2" *ngFor="let data of CommissionData; let j = index">
                    <!-- Individual rows from database -->
                    <tr *ngFor="let data1 of data.rep_data; let k = index">
                      <td>{{ data1.advt_invoice_no }}</td>
                      <td>{{ data1.advt_invoice_date}}</td>
                      <td>{{ data1.advt_name }}</td>
                      <td>{{ data1.DS_ISSUENAME }}</td>
                      <td>{{ data1.DS_ISSUEDATE }}</td>
                      <td>{{ data1.net_amount}}</td>
                      <td>{{ data1.pending_amt}}</td>
                      <td>{{ data1.rcv_amt}}</td>
                      <td>
                        <input type="number" (input)="CalculateAmount(data1, $event, j)"
                          style="width: 50px; height: 30px" [value]="data1.commissionPercentage ?? 15" min="0" max="100"
                          step="0.01" placeholder="%" />
                      </td>
                      <td>{{ data1.commissionAmount || 0 }}</td>
                      <td>{{ data1.com_paid_date }}</td>
                      <td>{{ data1.com_amt || 0 }}</td>
                      <td>{{ data1.balance_commission || 0 }}</td>
                      <td>
                        <input type="checkbox" (change)="copydata8(data1, $event)" style="width: 20px; height: 20px;">
                      </td>
                      <td></td>
                    </tr>

                    <!-- SUBTOTAL row for each record group -->
                    <!-- <tr class="total-row"
                      style="background-color: #d3f4ff; font-weight: bold; border-top: 2px solid #007bff;">
                      <td colspan="5" style="text-align: right; padding-right: 10px;">SUBTOTAL:</td>
                      <td>{{ getRecordTotal(data.rep_data, 'netAmount') }}</td>
                      <td>{{ getRecordTotal(data.rep_data, 'pendingAmount') }}</td>
                      <td>{{ getRecordTotal(data.rep_data, 'receivedAmount') }}</td>
                      <td></td>
                      <td>{{ getRecordTotal(data.rep_data, 'commissionAmount') }}</td>
                      <td></td>
                      <td>{{ getRecordTotal(data.rep_data, 'paidCommission') }}</td>
                      <td>{{ getRecordTotal(data.rep_data, 'unpaidCommission') }}</td>
                      <td>{{ getRecordTotal(data.rep_data, 'selectedAmount') }}</td>
                      <td></td>
                    </tr> -->
                  </tbody>

                  <!-- MANUAL ENTRY ROWS (Multiple) -->
                  <tbody *ngFor="let entryForm of manualEntries.controls; let i = index" [formGroup]="entryForm"
                    style="background-color: #fffacd;">
                    <tr style="border: 2px solid #ff9800;">
                      <td>
                        <input matInput type="text" formControlName="advt_invoice_no" placeholder="Enter Invoice No"
                          style="width: 100%; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="date" formControlName="advt_invoice_date"
                          style="width: 100%; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="text" formControlName="advt_name" placeholder="Enter Advt Name"
                          style="width: 100%; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="text" formControlName="DS_ISSUENAME" placeholder="Issue Name"
                          style="width: 100%; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="date" formControlName="DS_ISSUEDATE"
                          style="width: 100%; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="number" formControlName="net_amount" placeholder="0"
                          style="width: 80px; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="number" formControlName="pending_amt" placeholder="0"
                          style="width: 80px; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input matInput type="number" formControlName="rcv_amt" placeholder="0"
                          style="width: 80px; padding: 14px 12px; border: 1px solid #ccc;" />
                      </td>
                      <td>
                        <input type="number" formControlName="commissionPercentage"
                          style="width: 50px; height: 30px; border: 1px solid #ccc;" min="0" max="100" step="0.01"
                          placeholder="%" />
                      </td>
                      <td>{{ getManualCommissionAmount(i) | number:'1.2-2' }}</td>
                      <td>-</td>
                      <td>0</td>
                      <td>{{ getManualCommissionAmount(i) | number:'1.2-2' }}</td>
                      <td>
                        <input type="checkbox" formControlName="isSelected"
                          (change)="onManualEntryCheckboxChange($event)" style="width: 20px; height: 20px;">
                      </td>
                      <td>
                        <button type="button" mat-icon-button color="warn" (click)="removeManualEntry(i)"
                          *ngIf="manualEntries.length > 1" matTooltip="Remove Entry">
                          <mat-icon>delete</mat-icon>
                        </button>
                        <button type="button" mat-icon-button color="primary" (click)="clearManualEntry(i)"
                          matTooltip="Clear Entry">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>

                  <!-- Action Buttons for Manual Entries -->
                  <tbody>
                    <tr>
                      <td colspan="15" style="text-align: center; padding: 10px;">
                        <button type="button" mat-raised-button color="primary" (click)="addManualEntry()"
                          style="margin-right: 10px;">
                          <mat-icon>add</mat-icon> Add New Manual Entry
                        </button>
                        <button type="button" mat-raised-button color="accent" (click)="clearAllManualEntries()"
                          style="margin-right: 10px;">
                          Clear All Manual Entries
                        </button>
                        <span style="font-style: italic; color: #666;">
                          * Fill Invoice No and Received Amount to add manual entry
                        </span>
                      </td>
                    </tr>
                  </tbody>

                  <!-- Grand Total row -->
                  <tfoot style="background-color: #e0e0e0; font-weight: bold; font-size: 1.1em;">
                    <tr>
                      <td colspan="5" style="text-align: right;"><strong>GRAND TOTAL:</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td style="text-align: center;"></td>
                      <td>{{ getGrandTotal('commissionAmount') }}</td>
                      <td></td>
                      <td>{{ getGrandTotal('paidCommission') }}</td>
                      <td>{{ getGrandTotal('selectedAmount') }}</td>
                      <td colspan="2"></td>
                    </tr>
                  </tfoot>
                </table>
                <div style="display: flex; justify-content: center; margin-top: 30px; margin: 20px">
                  <button mat-raised-button type="button" class="btn btn-info" (click)="openAdvtBill2()">
                    Next
                  </button>
                </div>
              </mat-card>
            </table>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>19<br>
        Advt<br>
        Reprensantive Commission
      </ng-template>
      <mat-card style="margin-top: 2%; padding: 40px;">
        <form [formGroup]="CommissionReportForm">
          <div class="filter-form">
            <div class="filter-form">
              <div class="form-grid">
                <!-- Date Range -->
                <!-- <mat-form-field appearance="outline">
                  <mat-label>Enter Date</mat-label>
                  <mat-date-range-input [rangePicker]="pickerrcomm">
                    <input matStartDate formControlName="start" placeholder="Start date" />
                    <input matEndDate formControlName="end" placeholder="End date"
                      (dateChange)="getChangedDateContractM5()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="pickerrcomm"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerrcomm></mat-date-range-picker>
                </mat-form-field> -->


                <mat-form-field appearance="outline">
                  <mat-label>Enter Date</mat-label>

                  <div class="date-inline">
                    <input matInput type="date" formControlName="start" [min]="financialYearMin"
                      [max]="financialYearMax" />
                    <span class="dash"> - </span>
                    <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                      (blur)="getChangedDateContractM5()" />
                  </div>
                </mat-form-field>


                <!-- Representative -->
                <mat-form-field appearance="outline">
                  <mat-label>Representative Name</mat-label>
                  <input matInput formControlName="repname" [matAutocomplete]="autorepnames3"
                    (keyup)="getRepNames($event)" />
                  <mat-autocomplete autoActiveFirstOption #autorepnames3="matAutocomplete">
                    <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                    <mat-option *ngFor="let option of filterrep" [value]="option['rep_name']"
                      (onSelectionChange)="getContractRepNames($event)">
                      {{ option["rep_name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <!-- Issue / Grantha -->
                <mat-form-field style="margin-left: 3%;width: 100%;">
                  <mat-label>Issue/grantha : </mat-label>
                  <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                    <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                    <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                      {{ item.category }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field style="margin-left: 3%; width: 100%; ">
                  <mat-label>Issue Dates : </mat-label>
                  <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple required>
                    <mat-option value="ALL">All</mat-option>
                    <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"]
                      |
                      date :
                      "dd/MM/yyyy" }}
                      {{ item["issueName"] }}

                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Report Type -->
                <mat-form-field appearance="outline" style="margin-left: 7%; width: 100%;">
                  <mat-label>Select type of report</mat-label>
                  <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                    <mat-option value="PendingCommReport">Pending Commission
                    </mat-option>
                    <mat-option value="CompletedCommReport">Commission Paid
                    </mat-option>
                    <mat-option value="AllCommReport"> All Commission
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

          </div>


          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Advertiser Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of newadvtname" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
                
              </mat-select>
            </mat-form-field> -->

            <!-- 
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="PendingCommReport">Pending Commission
                </mat-option>
                <mat-option value="CompletedCommReport">Commission Paid
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Issue Categary : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" multiple>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtCategorylist" value="{{  item['category'] }}">{{ item["category"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          </div>

          <div>

          </div>


          <div class="form-row" style="margin: 3%;">

            <!-- <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReport()">Search</button>
            </div> -->
            <div style="display: flex; justify-content: center; margin-left: 45%;">
              <button mat-raised-button type="button" class="btn btn-info" (click)="practice()">Search</button>
            </div>
            <div style="display: flex; justify-content: center; margin-left: 20px;">
              <button mat-raised-button type="button" class="btn btn-info" (click)="showContractReport()">Get
                Report</button>
            </div>

          </div>
        </form>
        <!-- <div class="tableFixHead">
         
        </div> -->
      </mat-card>

      <mat-card class="mt-5" style="overflow-y: auto;
    overflow-x: scroll;
    height: 350px !important;">

        <table>
          <thead>
            <tr>
              <th colspan="10" class="comm-head">हिंदुस्थान प्रकाशन संस्था-विवेक साप्ताहिक</th>
            </tr>
            <tr>
              <th colspan="3" class="comm-head" style="text-align: left;">{{contractReportRepName}}</th>
              <th colspan="3" class="comm-head">Advt Representative Commission</th>
              <th colspan="4" class="comm-head">
                Date : {{startDate_contract | date : 'dd-MM-yyyy'}} To {{enddate_contract | date : 'dd-MM-yyyy'}}
              </th>
            </tr>

            <tr class="comm-head-2">
              <th colspan="2">Commission No</th>
              <th colspan="2">Rep Name</th>
              <th colspan="2">Comm Amount</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody class="comm-head-2" *ngFor="let data of CommissionData1; let j = index">
            <tr *ngFor="let data1 of data.rep_data; let k = index">
              <td colspan="2">{{data1.commision_no}}</td>
              <td colspan="2">{{data.rep_name}}</td>
              <td colspan="2">{{data1.com_amt}}</td>
              <td>
                <button class="btn btn-primary btn-sm" (click)="printCommission(data1)">Print</button>
                <button class="btn btn-danger btn-sm" (click)="deleteCommission(item['id'])">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <div style="display: flex; justify-content: center; margin-top: 30px; margin: 20px;">
          <button mat-raised-button type="button" class="btn btn-info" (click)="openAdvtBill2()">Next</button>
        </div> -->
      </mat-card>
    </mat-tab>





    <!-- <mat-tab label="Rep.wise Registration Report">
      <mat-form-field style="margin-top: 5%">
        <mat-label>Advt. Received Date</mat-label>
        <mat-date-range-input [formGroup]="RepwiseRegistrationreportRange" [rangePicker]="picker3">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date"
            (dateChange)="getChangedDateRepRegistrationReport()" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-date-range-picker #picker3></mat-date-range-picker>

        <mat-error *ngIf="
            RepwiseRegistrationreportRange.controls.start.hasError(
              'matStartDateInvalid'
            )
          ">Invalid start date
        </mat-error>
        <mat-error *ngIf="
            RepwiseRegistrationreportRange.controls.end.hasError(
              'matEndDateInvalid'
            )
          ">Invalid end date
        </mat-error>
      </mat-form-field>

      <mat-form-field style="margin-left: 3%">
        <mat-label>Representative Name : </mat-label>
        <mat-select name="rep" (selectionChange)="getRepNameReport($event)">
          <mat-option *ngFor="let rep of getAllRepList" [value]="rep['name']">
            {{ rep["name"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button style="margin-left: 3%" (click)="getAdvtRepRegistrationReport()" mat-raised-button color="primary">
        Get Report
      </button>

      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
        <div style="margin-top: 20px" class="tableFixHead">
          <button type="button" (click)="exportexcel('Rep_wise_registration_report')" class="btn btn-danger">
            Export
          </button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नोंदणी दिनांक</th>
                <th>Issue / Granth Name</th>
                <th>जाहिरातदार</th>
                <th>ग्राहकाचे नाव</th>
                <th>संपर्क क्रमांक</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>जाहिरातीचा आकार</th>
                <th>सूचना</th>
                <th>जाहिरात रक्कम</th>
                <th>सूट रक्कम</th>
                <th>निव्वळ रक्कम</th>
                <th>GST Amount</th>
                <th>GST Bill Amount</th>
                <th>जमा रक्कम</th>
                <th>येणे बाकी</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let advt of this.getAdvtDetailsRepReport; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ advt["registration_date"] | date : "dd-MM-yyy" }}</td>
                <td>{{ advt["issue_name"] }}</td>
                <td>{{ advt["advt_person_name"] }}</td>
                <td>{{ advt["advt_cust_name"] }}</td>
                <td>{{ advt["advt_person_mobile"] }}</td>
                <td>{{ advt["rep_name"] }}</td>
                <td>{{ advt["advt_size"] }}</td>
                <td>{{ advt["comment"] }}</td>
                <td>{{ advt["advt_amount"] | currency : "INR" : "symbol" }}</td>
                <td>
                  {{ advt["advt_discount"] | currency : "INR" : "symbol" }}
                </td>
                <td>
                  {{ advt["discounted_amount"] | currency : "INR" : "symbol" }}
                </td>
                <td>{{ advt["gst"] | currency : "INR" : "symbol" }}</td>
                <td>
                  {{ advt["total_amount"] | currency : "INR" : "symbol" }}
                </td>
                <td>{{ advt["part_amount"] | currency : "INR" : "symbol" }}</td>
                <td>
                  {{ advt["remaining_amount"] | currency : "INR" : "symbol" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab> -->



    <mat-tab>
      <ng-template mat-tab-label>
        20<br>
        Advt. Business<br>
        Rep.wise / District wise
      </ng-template>

      <form [formGroup]="BusinessReportForm">
        <!-- Filter Section -->
        <div class="filter-section" style="margin: 20px 0; padding: 0 3%;">
          <div class="form-row" style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center;">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 5%">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractM5()" />
              </div>
            </mat-form-field>

            <!-- Office Representative Dropdown -->
            <mat-form-field style="width: 25%; margin-left: 5%">
              <mat-label>Office Representative</mat-label>
              <mat-select #mySel1 formControlName="offrepname" (selectionChange)="getContractOffRepName($event)"
                multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" value="{{ item['off_rep_name'] }}">
                  {{ item["off_rep_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Country -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Country</mat-label>
              <mat-select formControlName="country" (selectionChange)="getCountry($event)">
                <mat-option *ngFor="let c of countries" [value]="c.country_name">
                  {{ c.country_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" (selectionChange)="getState($event)">
                <mat-option *ngFor="let c of states" [value]="c.state_name">
                  {{ c.state_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>District</mat-label>
              <mat-select formControlName="district" (selectionChange)="getDistricts($event)">
                <mat-option *ngFor="let c of cities" [value]="c.district_name">
                  {{ c.district_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Taluka -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="taluka">
                <mat-option *ngFor="let c of talukas" [value]="c.taluka_name">
                  {{ c.taluka_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 25%; margin-left: 5%">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 25%; margin-left: 5%">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates1($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
                  date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Report Type Dropdown -->
            <mat-form-field appearance="outline" style="width: 35%; margin-left: 5%">
              <mat-label>Select Type of Report</mat-label>
              <mat-select #mySel2 (selectionChange)="getContractReportType($event)">
                <mat-option value="BusinessReportIndetail">Off. Rep. wise Business Report - In Detail</mat-option>
                <mat-option value="BusinessReportBriefly">Off. Rep. wise Business Report - Briefly</mat-option>
                <mat-option value="BusinessReportVBriefly">Off. Rep. wise Business Report - Very Briefly</mat-option>
                <mat-option value="IssueBusinessReport">Regular/Special Issue Business Report</mat-option>
                <mat-option value="IssueBusinessDetailAdvtReport">Personal Business Report</mat-option>
                <mat-option value="IssueYearBusinessAdvtReport">Past Few Year Issue/Granth Advt Review</mat-option>
                <mat-option value="JahitatJamaPratinidiReport">Advt. Amt. Collection Report - Briefly</mat-option>
                <mat-option value="JahitatJamaReport">Advt. Amt. Collection Report - Very Briefly</mat-option>
                <mat-option value="YeneBakiJahiratPratinidiReport">Advt. Outstanding Report - Briefly</mat-option>
                <mat-option value="YeneBakiJahiratReport">Advt. Outstanding Report - Very Briefly</mat-option>


              </mat-select>
            </mat-form-field>

            <!-- Search Button -->
            <button type="button" mat-raised-button color="primary" (click)="showContractBusiness()">
              Search
            </button>

            <!-- Get Report Button -->
            <button mat-raised-button color="primary" (click)="getBussinessReport()">
              Get Report
            </button>

          </div>
        </div>
      </form>
      <!-- Report Table Section -->
      <div class="add-new-subscriber mat-elevation-z4" style="margin: 20px 3%; overflow-x: auto;" id="excel-table">
        <div style="margin-top: 20px;" class="tableFixHead">

          <!-- Export Button -->
          <button type="button" (click)="exportexcel('advt_bussiness_report')" class="btn btn-danger"
            style="margin-bottom: 15px;">
            Export
          </button>

          <!-- Data Table -->
          <table class="table table-striped table-bordered text-center">
            <thead class="thead-dark">
              <tr>
                <th>अ.क्र.</th>
                <th>प्रतिनिधींचे नाव</th>
                <th>जिल्हा</th>
                <th>तालुका</th>
                <th>एप्रिल</th>
                <th>मे</th>
                <th>जून</th>
                <th>जुलै</th>
                <th>ऑगस्ट</th>
                <th>सप्टेंबर</th>
                <th>ऑक्टोबर</th>
                <th>नोव्हेंबर</th>
                <th>डिसेंबर</th>
                <th>जानेवारी</th>
                <th>फेब्रुवारी</th>
                <th>मार्च</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rep of transformedData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ rep.rep_name }}</td>
                <td>{{ rep.district }}</td>
                <td>{{ rep.taluka }}</td>
                <td *ngFor="let month of monthColumns">
                  {{ rep.months[month] || 0 }} <!-- ✅ reads correct month column -->
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </mat-tab>



    <!-- <mat-tab label="Advertisement Account">
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important">
        <div style="margin-top: 20px">
          <button (click)="getAdvtPayments()" mat-fab color="warn" class="btn"
            aria-label="Example icon button with a refresh icon">
            <mat-icon>refresh</mat-icon>
          </button>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Rep. Name</th>
                <th>Outstanding</th>
                <th>Claim Against</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of this.advtpaymentList; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ book["name"] }}</td>
                <td>₹ {{ book["totalAmount"] }}</td>
                <td>{{ book["claim_name"] }}</td>
                <td>
                  <button type="button" class="btn btn-danger btn-sm" (click)="displayBookPayment(book)">
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab> -->





    <mat-tab>
      <ng-template mat-tab-label>21<br>
        Advertiesment<br>
        Representative
      </ng-template>
      <mat-card style="margin-top: 20px">
        <table class="table table-striped table-fixed">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Representative Name</th>
              <th>Representative Mobile No</th>
              <th>Representative District</th>
              <th>Office Representative</th>
              <th>Comm%</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of advtwisereplist; let i = index">
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ i + 1 }}</td>
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ item["rep_name"] }}</td>
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ item["rep_mob_no"] }}</td>
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ item["district"] }}</td>
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ item["off_rep_name"] }}</td>
              <td style="font-weight: bolder;font-size: 20px;color: black;">{{ item["com_percentage"] }}</td>
              <td>
                <button type="button" class="btn btn-info" (click)="update(item)">
                  Update
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab>




    <mat-tab>
      <ng-template mat-tab-label>22<br>
        Add<br>
        Advt Type
      </ng-template>
      <mat-card class="card">
        <h3>Add Advt Type</h3>
        <form class="form" [formGroup]="Addadvttype">
          <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
            <mat-label>Advertiser Type :</mat-label>
            <input matInput formControlName="advttype" maxlength="16" required />
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
            <mat-label>Advertiser Type Details :</mat-label>
            <input matInput formControlName="advttypedeatils" required />
          </mat-form-field>

          <button type="button" class="new-button-css" *ngIf="Addadvttype.get('id').value === ''"
            [disabled]="!Addadvttype.valid" (click)="saveadvttype()">
            Add
          </button>
          <button type="button" class="new-button-css " *ngIf="Addadvttype.get('id').value !== ''"
            [disabled]="!Addadvttype.valid" (click)="saveupdatedata()">
            Update
          </button>
          <button type="button" class="new-button-css" style="margin-left: 10px;" (click)="typeclear()">
            Clear
          </button>
        </form>


      </mat-card>

      <mat-card>
        <div class="col-md-12 mt-3">
          <table>
            <thead>
              <th>Sr</th>
              <th>Advt Type</th>
              <th>Advt Type Details</th>
              <th>Action</th>
            </thead>

            <tbody>
              <tr *ngFor="let data of oldadvttype; let i = index">
                <td>{{i+1}}</td>
                <td>{{data.advt_type}}</td>
                <td>{{data.advt_types_select}}</td>
                <!-- <td [>{{ data.id }}</td> -->
                <td>
                  <button type="button" class="btn-sm btn-outline-info" matTooltip="Update"
                    (click)="updateadvttype(data)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <!-- <button type="button" style="margin-left: 5%;" type="button" class="btn-outline-danger btn-sm"
                  matTooltip="Remove" (click)="removeState(item['state_id'])">
                  <mat-icon>delete</mat-icon>
                </button> -->
                  <button type="button" type="button" class="btn-outline-danger btn-sm" matTooltip="Remove"
                    (click)="removeadvttype(data['id'])">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>

            </tbody>

          </table>
        </div>
      </mat-card>


    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>23<br>
        Add OutStanding<br>
        Old Data
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="Advtremainingamt">
          <div class="row text-center">
            <div class="col-md-12" style="color: black; font-size: 25px; margin-bottom: 20px;">
              Advt Previous Data
            </div>
            <div class="col-md-12">
              <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                <mat-label>Advertiser Name :</mat-label>
                <input  matInput formControlName="advtName" required (keyup)="getAdvtNames($event)"
                  [matAutocomplete]="autoadv" />
                <mat-autocomplete #autoadv="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name1($event, option)"
                    *ngFor="let option of filteredOptions | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->
              <!-- <mat-form-field class="example-form-field" style="margin-top: 5%">
                <mat-label>Advt. Name</mat-label>
                <input matInput type="text" [(ngModel)]="advt_name" (ngModelChange)="get_advt_name_filter($event)" />
              </mat-form-field> -->

              <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-right: 3%">
                <mat-label>Advertiser Name :</mat-label>
                <!-- formControlName="sadvtname" -->
                <input matInput formControlName="advtName" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
                <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                    [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%" appearance="outline" style="width: 25%; margin-right: 3%">
                <mat-label>Office Representative : </mat-label>
                <mat-select #mySelr1 (selectionChange)="getOfficeRep($event)" formControlName="off_rep_name">
                  <!-- <mat-option value="ALL" (click)="toggleAllSelectionr1()">All</mat-option> -->
                  <mat-option *ngFor="let item of pp_off_rep_names" value="{{ item['off_rep_name'] }}">{{
                    item["off_rep_name"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="margin-right: 3%; width: 25%;">
                <mat-label>Representative Name : </mat-label>
                <input formControlName="rep_name" matInput [matAutocomplete]="autorepnames"
                  (keyup)="getRepNames($event)" />
                <!-- <mat-select  formControlName="rep_name" required #mySel1 (selectionChange)="getContractOffRepName($event)" >
                  <mat-option *ngFor="let item of GetOffRep" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                    }}
                  </mat-option>
                </mat-select> -->
                <mat-autocomplete autoActiveFirstOption #autorepnames="matAutocomplete">
                  <mat-option (selectionChange)="getContractRepNames($event)" *ngFor="let option of filterrep"
                    [value]="option['rep_name']">
                    {{ option["rep_name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <!-- <mat-form-field appearance="outline" style="margin-right: 3%; width: 25%;">
                <mat-label>Representative Name :</mat-label>
                <input formControlName="rep_name" matInput [matAutocomplete]="autorepname" />
                <mat-autocomplete autoActiveFirstOption #autorepname="matAutocomplete">
                  <mat-option (onSelectionChange)="getContractOffRepName(option)"
                    *ngFor="let option of filteredOptions1" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->



              <div class="col-md-12">

                <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                  <mat-label>Invoice Number</mat-label>
                  <input matInput formControlName="invoiceNumber" [(ngModel)]="invoicenumber"
                    (keyup)="generateinv($event)" maxlength="16" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                  <mat-label>Invoice Date</mat-label>
                  <input matInput [matDatepicker]="startDatePicker10" formControlName="invoicedate"
                    (dateChange)="GenerateCRno2()" formControlName="invoiceDate" />
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker10"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker10></mat-datepicker>
                </mat-form-field>
                <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%;">
                <mat-label>Advt Name</mat-label>
                <input matInput formControlName="advtName" required/>
              </mat-form-field> -->

                <mat-form-field class="example-full-width" style="margin-right: 3%; width: 25%" appearance="outline">
                  <mat-label>Issue Name : </mat-label>
                  <!-- <mat-select formControlName="issueName" (selectionChange)="getIssuesAdvtNames1($event)" required>
                  <mat-option *ngFor="let item of issuesub" value="{{ item.issueName }}">
                    {{ item.issueName }}
                  </mat-option>
                </mat-select> -->
                  <input formControlName="issueName" matInput [matAutocomplete]="autorepnames2"
                    (keyup)="getIssueNames($event)" />
                  <mat-autocomplete autoActiveFirstOption #autorepnames2="matAutocomplete">
                    <mat-option (onSelectionChange)="getIssuesAdvtNames1($event)" *ngFor="let item of oldissuename"
                      value="{{ item.issueName }}">
                      {{ item.issueName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                <mat-label>Invoice Date</mat-label>
                <input matInput formControlName="invoiceDate" required placeholder="YYYY/MM/DD"/>
              </mat-form-field> -->

              <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                <mat-label>Invoice Date</mat-label>
                <input formControlName="invoiceDate" (dateChange)="addEvent($event)" matInput [matDatepicker]="pickerod">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="pickerod"></mat-datepicker-toggle>
                <mat-datepicker #pickerod ></mat-datepicker>
              </mat-form-field> -->

              <!-- <mat-form-field appearance="outline" style="margin-right: 3%; width: 25%;">
                <mat-label>Representative Name : </mat-label>
                <input formControlName="rep_name" matInput [matAutocomplete]="autorepnames"  (keyup)="getRepNames($event)"/>
             
                <mat-autocomplete autoActiveFirstOption #autorepnames="matAutocomplete">
                  <mat-option (selectionChange)="getContractRepNames($event)"
                    *ngFor="let option of filterrep" [value]="option['rep_name']">
                    {{ option["rep_name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->



              <div class="col-md-12">
                <mat-form-field class="example-full-width" style="margin-right: 3%; width: 25%" appearance="outline">
                  <mat-label>Issue Dates : </mat-label>
                  <input formControlName="issueDate" matInput [matAutocomplete]="autorepnames1"
                    (keyup)="getIssuedateNames($event)" />
                  <mat-autocomplete autoActiveFirstOption #autorepnames1="matAutocomplete">
                    <mat-option *ngFor="let item of filterissuedate"
                      (onSelectionChange)="setissueDate(item['issueDate'])"
                      value="{{ [item['issueDate'] | date:'dd/MM/yyyy', item['issueName'],item['publishedDate'] | date : 'dd/MM/yyyy'] }}">{{
                      item["issueDate"] | date : "dd-MM-yyy" }}
                      {{ item["issueName"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%; ">
                  <mat-label>Total Amount</mat-label>
                  <input matInput formControlName="totalamt" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-full-width" style="width: 15%; margin-right: 3%;">
                  <mat-label>Received Amount</mat-label>
                  <input matInput formControlName="receivedAmount" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-full-width" style="width: 15%; margin-right: 3%;  ">
                  <mat-label>Credit Amount</mat-label>
                  <input matInput formControlName="CreditdAmount" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                  <mat-label>Pending Amount</mat-label>
                  <input matInput formControlName="pendingamt" [value]="Advtremainingamt.get('pendingamt').value" />
                </mat-form-field>

                <button type="button" class="new-button-css" [disabled]="!Advtremainingamt.valid"
                  [class.disabled-button]="Advtremainingamt.invalid" (click)="saveolddata()" disabled>
                  Add
                </button>








              </div>
              <div class="col-md-12">
                <!-- <mat-form-field appearance="outline" class="example-full-width" style="width: 25%; margin-right: 3%;">
                  <mat-label>Credit Amount</mat-label>
                  <input matInput formControlName="CreditdAmount" />
                </mat-form-field> -->
                <!-- <mat-form-field appearance="outline" class="example-full-width"
                  style="width: 25%; margin-right: 3%; margin-left: -41%;">
                  <mat-label>Pending Amount</mat-label>
                  <input matInput formControlName="pendingamt" [value]="Advtremainingamt.get('pendingamt').value"
                    disabled />
                </mat-form-field> -->

                <!-- <button type="button" class="new-button-css" [disabled]="!Advtremainingamt.valid"
                  [class.disabled-button]="Advtremainingamt.invalid" (click)="saveolddata()">
                  Add
                </button> -->
                <!-- <button type="button" class="new-button-css" (click)="saveolddata()">Add</button> -->
                <!-- <button type="button" class="new-button-css" [disabled]="!Advtremainingamt.valid" (click)="saveolddata()">Add</button> -->

              </div>
            </div>
          </div>
        </form>
      </mat-card>
      <mat-card>
        <div class="col-md-12 mt-3">
          <table>
            <thead>
              <th>Invoice Number</th>
              <th>Invoice Date</th>
              <th>Creation Date</th>
              <th>Advt Name</th>
              <th>Issue Name</th>
              <th>Issue Date</th>
              <th>Total Amount</th>
              <th>Received Amount</th>
              <th>Pending Amount</th>
              <th>Action</th>
            </thead>

            <tbody>
              <tr *ngFor="let data of old_data; let i = index">
                <td>{{data.invoice_number}}</td>
                <td>{{data.invoice_date}}</td>
                <td>{{data.creation_date}}</td>
                <td>{{data.advt_name}}</td>
                <td>{{data.issue_name}}</td>
                <td>{{data.issue_date}}</td>
                <td>{{data.total_amt}}</td>
                <td>{{data.rcv_amt}}</td>
                <td>{{data.pending_amt}}</td>
                <!-- <td [>{{ data.id }}</td> -->
                <td>
                  <button type="button" class="btn-sm btn-outline-info" matTooltip="Update"
                    (click)="updateolddata(data)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <!-- <button type="button" style="margin-left: 5%;" type="button" class="btn-outline-danger btn-sm"
                  matTooltip="Remove" (click)="removeState(item['state_id'])">
                  <mat-icon>delete</mat-icon>
                </button> -->
                  <button type="button" type="button" class="btn-outline-danger btn-sm" matTooltip="Remove"
                    (click)="removeolddata(data['id'])">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>

            </tbody>

          </table>
        </div>
      </mat-card>

    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>
        22<br />
        Address Label
      </ng-template>

      <mat-card class="card">
        <form [formGroup]="AddressForm" class="form">

          <!-- Row 1 -->
          <div class="form-row">

            <!-- Date Range -->
            <mat-form-field appearance="outline" style="margin-left: 5%; width: 25%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="start" [min]="financialYearMin" [max]="financialYearMax" />
                <span class="dash"> - </span>
                <input matInput type="date" formControlName="end" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateContractAddress()" />
              </div>
            </mat-form-field>

            <!-- Issue / Grantha -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Issue / Grantha</mat-label>
              <mat-select formControlName="issuename" (selectionChange)="getIssues($event)">
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of advtCategorylist" [value]="item.category">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Issue Dates -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Issue Dates</mat-label>
              <mat-select formControlName="issueDates" multiple (selectionChange)="getAdvtDates1($event)">
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames" [value]="item.id">
                  {{ item.issueDate | date:'dd/MM/yyyy' }} - {{ item.issueName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Office Representative -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Office Representative</mat-label>
              <mat-select multiple formControlName="officeRep" (selectionChange)="getContractOffRepName($event)">
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of pp_off_rep_names" [value]="item.off_rep_name">
                  {{ item.off_rep_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Representative</mat-label>
              <mat-select multiple formControlName="repname" (selectionChange)="getRepName1($event)">
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of repNamesOfRegReport" [value]="item.rep_name">
                  {{ item.rep_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Country -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Country</mat-label>
              <mat-select formControlName="country" (selectionChange)="getCountry($event)">
                <mat-option *ngFor="let c of countries" [value]="c.country_name">
                  {{ c.country_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <!-- Row 2 -->
          <div class="form-row">

            <!-- Representative -->
            <!-- State -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" (selectionChange)="getState($event)">
                <mat-option *ngFor="let c of states" [value]="c.state_name">
                  {{ c.state_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- District -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>District</mat-label>
              <mat-select formControlName="district" (selectionChange)="getDistricts($event)">
                <mat-option *ngFor="let c of cities" [value]="c.district_name">
                  {{ c.district_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Taluka -->
            <mat-form-field appearance="outline" class="form-field" style="width: 25%; margin-left: 5%">
              <mat-label>Taluka</mat-label>
              <mat-select formControlName="taluka">
                <mat-option *ngFor="let c of talukas" [value]="c.taluka_name">
                  {{ c.taluka_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 5%; width: 25%">
              <mat-label>Advt. Type : </mat-label>
              <mat-select formControlName="advtType">
                <mat-option *ngFor="let item of advtTypes" value="{{ item['advt_types_select'] }}">
                  {{ item["advt_type"] }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 5%; width: 25%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="AddressL">Address
                </mat-option>
                <mat-option value="AddressList">Address List
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div style="display: flex; justify-content: center; width: 25%; margin-left: 5%">
              <button mat-raised-button type="button" class="btn btn-info"
                (click)="showContractReportAddress()">Search</button>
            </div>

          </div>

        </form>
      </mat-card>
    </mat-tab>


    <mat-tab label="Dengi Report">
      <mat-card class="expense">
        <form [formGroup]="expense">
          <h3 class="text-center" style="font-size: 25px;">DENGI REPORT</h3>
          <div class="form-row" style="margin-top: 10px;">
            <mat-form-field appearance="outline" style="margin-left: 2%; width: 15%">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start" />
            </mat-form-field>

            <span class="date-separator" style="margin-left: 1%;margin-top: 15px;">-</span>

            <mat-form-field appearance="outline" style="margin-left: 1%;width: 15%">
              <mat-label>End Date</mat-label>
              <input matInput type="date" formControlName="end" (blur)="expenseledgerDateRange()" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2%; width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Select Main Expense</mat-label>
              <mat-select formControlName="expnameother" (selectionChange)="getSubExpByMainExp($event)">
                <mat-option *ngFor="let exp of mainExpData" [value]="{ id: exp['id'], source: exp['source'] }">
                  {{ exp["exp_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="subexpense" style="margin-left: 2%; width: 30%" class="example-full-width"
              appearance="outline">
              <mat-label>Select Sub Expense</mat-label>
              <mat-select formControlName="subexpnameother" (selectionChange)="getSubExpName1($event)">
                <mat-option *ngFor="let exp of subExpData" value="{{ exp['sub_id'] }}">{{ exp["sub_exp_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button style="margin-left: 30%; width: 30%;margin-top: 20px;margin-bottom: 20px;" type="button"
              [disabled]="expense.invalid" mat-raised-button color="primary" (click)="expense_report_new()">
              Get Report
            </button>
          </div>
        </form>
      </mat-card>

    </mat-tab>



  </mat-tab-group>
</div>